// Shape version for localStorage.sponsorData. Bump whenever the stored fields
// change, so records written by an older build are not read back as if they
// were written by this one.
var SPONSOR_DATA_VERSION = 2;

// Enrollment type for sponsor editability + attribution. Same rule as
// from-param-tracker.liquid: only "sponsor" / "self" count, from the URL first,
// else the saved type ("" when neither). Only "self" locks the sponsor.
function currentEnrollmentType() {
  const valid = (t) => (t === "sponsor" || t === "self" ? t : "");
  return (
    valid(new URLSearchParams(window.location.search).get("type")) ||
    valid(localStorage.getItem("enrollment_type"))
  );
}

// Keeps attribution in step with a manually picked sponsor, so the landing
// link's values can't outlive the pick. Called from the enrollment field and
// from the header rep modal (global.js). Self-led can't change the sponsor.
function syncSelectedSponsor(rep, fullName) {
  const type = currentEnrollmentType();
  if (type === "self" || !rep) return;

  // No valid rep # → change nothing; a partial update would leave apex.sponsor
  // on the old rep while the referral names the new one.
  const repId = Number(rep["rep_#"]);
  if (!Number.isInteger(repId) || repId <= 0) return;

  // sponsor_id cookie is read by apex-attribution.js for apex.sponsor; the
  // manual flag stops resolveAndSetRep() / cart-attributes.liquid from
  // re-applying the landing link's rep or CILIKey.
  const expires = new Date(Date.now() + 90 * 86400000).toUTCString();
  document.cookie = `sponsor_id=${repId}; expires=${expires}; path=/`;
  localStorage.setItem("manualMemberSelected", "true");

  if (type !== "sponsor") {
    // No type: a manual pick is a "Sponsor Lookup" (apex-attribution.js
    // readReferral() → value = sponsor_id cookie). Drop the landing link's
    // referral and from_param so they don't outlive the pick.
    localStorage.removeItem("apex_referral");
    localStorage.removeItem("from_param");
    return;
  }

  // from-param-tracker.liquid re-sends from_param as retail_web_site_name on
  // every load. ?from is a rep handle (/pub/handle/{handle}), and rep search
  // results carry `handle`.
  if (rep.handle) localStorage.setItem("from_param", rep.handle);
  else localStorage.removeItem("from_param");

  // apex-attribution.js re-reads this on every non-checkout sync; match the
  // value the enrollment checkout write sends.
  localStorage.setItem("apex_referral", JSON.stringify({
    key: "Sponsor-led Enrollment",
    value: fullName || String(repId),
  }));
}

window.cbdEnrollmentSponsor = {
  // On the enrollment page, self-led may not change the sponsor from the
  // header modal. (Off this page cbdEnrollmentSponsor is undefined.)
  headerLocked: () => currentEnrollmentType() === "self",
  sync: syncSelectedSponsor,
};

function isSponsorFlow() {
  const params = new URLSearchParams(window.location.search);

  const urlType = params.get("type");
  const localType = localStorage.getItem("enrollment_type");

  const isSponsor =
    urlType === "sponsor" ||
    localType === "sponsor";

  /* SELF flow should also use sponsor step */
  const isSelf =
    urlType === "self" ||
    localType === "self";

  /* NON SPONSOR FLOW */
  if (!isSponsor && !isSelf) {
    const sponsorSidebar = document.querySelector(".sponsor-sidebar-step");
    const sponsorStep = document.querySelector(".sponsor-step");

    /* hide sponsor sidebar */
    if (sponsorSidebar) {
      sponsorSidebar.style.display = "none";
    }

    /* hide sponsor form */
    if (sponsorStep) {
      sponsorStep.style.display = "none";
      sponsorStep.classList.remove("active");
    }

    /* FIX STEP NUMBERING */
    const allSteps = document.querySelectorAll(
      ".membership-cart .all-step li"
    );

    allSteps.forEach((step, index) => {
      const numberEl = step.querySelector(".number");

      if (numberEl) {
        numberEl.textContent = index + 1;
      }
    });

    /* auto open first step */
    const firstLi = document.querySelector(
      '.membership-cart ul li[data-index="1"]'
    );

    if (firstLi) {
      firstLi.click();
    }
  }

  return isSponsor || isSelf;
}
/* ======================================
   CHANGE SPONSOR TITLE BASED ON URL
====================================== */
function updateSponsorHeading() {
  const params = new URLSearchParams(window.location.search);
  const urlType = params.get("type");

  const heading = document.querySelector(
    ".sponsor-step .headings-common h2"
  );

  if (!heading) return;

  if (urlType === "self") {
    heading.textContent = "Your Details";
  } 
  else if (urlType === "sponsor") {
    heading.textContent = "New Affiliate Details";
  }
}


function isSelfFlow() {
  const params = new URLSearchParams(window.location.search);

  const urlType = params.get("type");
  const localType = localStorage.getItem("enrollment_type");

  return (
    urlType === "self" ||
    localType === "self"
  );
}

function getSponsorData() {
  try {
    return JSON.parse(localStorage.getItem("sponsorData"));
  } catch {
    return null;
  }
}

/* ======================================
   SELF FLOW → ONLY COUNTRY FIELD
====================================== */
function handleSelfFlowFields() {
  if (!isSelfFlow()) return;

  const form = document.querySelector(".sponsor-form form");
  if (!form) return;

  const inputs = form.querySelectorAll("input");

  /* hide first name */
  if (inputs[0]) {
    inputs[0].closest(".form-group").style.display = "none";
    inputs[0].required = false;
  }

  /* hide last name */
  if (inputs[1]) {
    inputs[1].closest(".form-group").style.display = "none";
    inputs[1].required = false;
  }

  /* hide address */
  if (inputs[2]) {
    inputs[2].closest(".form-group").style.display = "none";
    inputs[2].required = false;
  }

  /* hide city */
  if (inputs[3]) {
    inputs[3].closest(".form-group").style.display = "none";
    inputs[3].required = false;
  }

  /* hide zip */
  if (inputs[4]) {
    inputs[4].closest(".form-group").style.display = "none";
    inputs[4].required = false;
  }
}

/* ======================================
   SPONSOR SIDEBAR UI STATUS
====================================== */
function updateSponsorSidebarStatus() {
  const sponsorSaved = !!localStorage.getItem("sponsorData");

  const sponsorSidebar = document.querySelector(".sponsor-sidebar-step");
  const numberBox = sponsorSidebar?.querySelector(".product-number-img");
  const iconImage = sponsorSidebar?.querySelector(".product-box-image");
  const number = sponsorSidebar?.querySelector(".number");

  if (!sponsorSidebar || !numberBox) return;

  if (sponsorSaved) {
    /* GREEN when filled */
    numberBox.style.background = "#008000";
    numberBox.style.color = "#fff";

    if (iconImage) {
      iconImage.style.display = "block";
    }

    if (number) {
      number.style.display = "none";
    }
  } else {
    /* ORANGE when empty */
    numberBox.style.background = "#76A48E";
    numberBox.style.color = "#fff";

    if (iconImage) {
      iconImage.style.display = "none";
    }

    if (number) {
      number.style.display = "block";
    }
  }
}

/* ======================================
   FIX NAVIGATION
====================================== */
document.addEventListener("click", function (e) {
  if (!isSponsorFlow()) return;

  const stepClick = e.target.closest(
    ".membership-cart ul li, .prev-button, .proceed"
  );

  if (!stepClick) return;

  const sponsorSaved = !!localStorage.getItem("sponsorData");
  if (!sponsorSaved) return;

  setTimeout(() => {
    syncMembershipNavigation();
  }, 200);
});

/* ======================================
   MEMBERSHIP NAVIGATION SYNC
====================================== */
function syncMembershipNavigation() {
  const navigation = document.querySelector(".membership-navigation");
  if (!navigation) return;

  const activeStep = document.querySelector(".membership.active");
  if (!activeStep) return;

  const prevBtn = navigation.querySelector(".prev-button");
  const proceedBtn = navigation.querySelector(".proceed");

  const stepIndex =
    parseInt(activeStep.getAttribute("data-index")) || 0;

  /* FULL RESET */
  navigation.style.display = "flex";
  navigation.style.justifyContent = "center";
  navigation.style.alignItems = "center";
  navigation.style.gap = "5px";

  navigation.classList.add("active");
  navigation.classList.add("show-cls");

  if (prevBtn) {
    prevBtn.style.display = "inline-flex";
    prevBtn.style.pointerEvents = "auto";
    prevBtn.style.opacity = "1";
  }

  if (proceedBtn) {
    proceedBtn.style.display = "inline-flex";
    proceedBtn.style.pointerEvents = "auto";
    proceedBtn.style.opacity = "1";
  }

  /* sponsor step */
  if (
    activeStep.classList.contains("sponsor-step") ||
    stepIndex === 0
  ) {
    navigation.style.display = "none";
    return;
  }

  /* step 1 */
  if (stepIndex === 1 && prevBtn) {
    prevBtn.style.pointerEvents = "none";
    prevBtn.style.opacity = "0.4";
  }

  /* final step */
  if (
    activeStep.classList.contains("finish-step") &&
    proceedBtn
  ) {
    proceedBtn.style.pointerEvents = "none";
    proceedBtn.style.opacity = "0.4";
  }
}

/* ======================================
   OPEN SPONSOR STEP
====================================== */
function openSponsorStep() {
  const sponsorStep = document.querySelector(".sponsor-step");
  const sponsorSidebar = document.querySelector(".sponsor-sidebar-step");
  const navigation = document.querySelector(".membership-navigation");

  document.querySelectorAll(".membership").forEach((el) => {
    el.classList.remove("active");
  });

  document.querySelectorAll(".membership-cart ul li").forEach((el) => {
    el.classList.remove("active");
  });

  sponsorStep?.classList.add("active");
  sponsorSidebar?.classList.add("active");

  if (navigation) {
    navigation.style.display = "none";
    navigation.classList.remove("active");
    navigation.classList.remove("show-cls");
  }
}

/* ======================================
   OPEN MEMBERSHIP STEP
====================================== */
function openMembershipStep(stepNumber = 1) {
  const navigation = document.querySelector(".membership-navigation");

  document.querySelectorAll(".membership").forEach((el) => {
    el.classList.remove("active");
  });

  document.querySelectorAll(".membership-cart ul li").forEach((el) => {
    el.classList.remove("active");
  });

  document.querySelector(".sponsor-sidebar-step")
    ?.classList.remove("active");

  const targetStep = document.querySelector(
    `.membership[data-index="${stepNumber}"]`
  );

  const targetLi = document.querySelector(
    `.membership-cart ul li[data-index="${stepNumber}"]`
  );

  targetStep?.classList.add("active");
  targetLi?.classList.add("active");

  if (navigation) {
    navigation.style.display = "flex";
    navigation.classList.add("active");
    navigation.classList.add("show-cls");
  }

  syncMembershipNavigation();
}

/* ======================================
   LOCK STEPS BEFORE SPONSOR SUBMIT
====================================== */
function lockMembershipSteps() {
  if (!isSponsorFlow()) return;

  const sponsorSaved = !!localStorage.getItem("sponsorData");

  const allSteps = document.querySelectorAll(
    ".membership-cart ul li"
  );

  allSteps.forEach((step) => {
    step.classList.remove("blocked-step");

    if (!sponsorSaved) {
      step.classList.add("blocked-step");

      step.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();

        alert("Please complete affiliate details first");
        openSponsorStep();

        return false;
      };
    } else {
      step.onclick = null;
      step.classList.remove("blocked-step");
    }
  });
}

/* ======================================
   PAGE LOAD
====================================== */
document.addEventListener("DOMContentLoaded", function () {
  /* GOOGLE ADDRESS AUTOCOMPLETE */
  updateSponsorHeading();
  const sponsorForm = document.querySelector(".sponsor-form form");

  if (sponsorForm) {
    const inputs = sponsorForm.querySelectorAll("input");
    const countrySelect = sponsorForm.querySelector("select");

    const addressInput = inputs[2]; // address
    const cityInput = inputs[3];    // city
    const zipInput = inputs[4];     // zip

    if (addressInput && window.google) {
      const autocomplete = new google.maps.places.Autocomplete(
        addressInput,
        {
          types: ["address"],
          fields: [
            "address_components",
            "formatted_address",
            "geometry"
          ]
        }
      );

      autocomplete.addListener("place_changed", function () {
        const place = autocomplete.getPlace();

        if (!place.geometry) {
          alert("Please select valid address from suggestions");

          addressInput.value = "";
          cityInput.value = "";
          zipInput.value = "";
          return;
        }

        let city = "";
        let zip = "";
        let country = "";

        place.address_components.forEach(function (component) {
          const types = component.types;

          if (
            types.includes("locality") ||
            types.includes("administrative_area_level_2")
          ) {
            city = component.long_name;
          }

          if (types.includes("postal_code")) {
            zip = component.long_name;
          }

          if (types.includes("country")) {
            country = component.short_name;
          }
        });

        addressInput.value = place.formatted_address || "";
        if (cityInput) cityInput.value = city;
        if (zipInput) zipInput.value = zip;

        if (countrySelect && country) {
          const option = countrySelect.querySelector(
            `option[data-value="${country}"]`
          );

          if (option) {
            option.selected = true;
            countrySelect.dispatchEvent(
              new Event("change", { bubbles: true })
            );
          }
        }
      });
    }
  }
  const params = new URLSearchParams(window.location.search);
  const urlType = params.get("type");
  const lastType = localStorage.getItem("last_enrollment_type");

  if (urlType && lastType !== urlType) {
    let stepData = JSON.parse(
      localStorage.getItem("enrollmentStepData") || "{}"
    );

    /* only change step */
    stepData.step = "0";

    localStorage.setItem(
      "enrollmentStepData",
      JSON.stringify(stepData)
    );

    /* Switching enrollment type restarts the walkthrough at step 0, so the
       persisted "visited" steps (custom.js VISITED_STEPS_KEY) no longer apply.
       Clearing here keeps saved progress from outliving the flow it belongs to. */
    localStorage.removeItem("enrollmentVisitedSteps");

    /* 🔥 if SELF → SPONSOR then remove sponsorData so sponsor locks again */
    if (lastType === "self" && urlType === "sponsor") {
      localStorage.removeItem("sponsorData");

      /* run lock again */
      if (typeof lockMembershipSteps === "function") {
        setTimeout(() => {
          lockMembershipSteps();
          openSponsorStep();
        }, 300);
      }
    }

    /* save current type */
    localStorage.setItem("last_enrollment_type", urlType);
  }
  const sponsorSidebar = document.querySelector(
    ".sponsor-sidebar-step"
  );

  /* non sponsor flow */
  if (!isSponsorFlow()) {
    if (sponsorSidebar) {
      sponsorSidebar.style.display = "none";
    }
    return;
  }

  const savedSponsor = getSponsorData();
  const form = document.querySelector(".sponsor-form form");

  /* SELF FLOW UI */
  handleSelfFlowFields();

  /* AUTOFILL SPONSOR FORM */
  if (savedSponsor && form) {
    const inputs = form.querySelectorAll("input");

    /* only full autofill for sponsor flow */
    if (!isSelfFlow() && inputs.length >= 5) {
      inputs[0].value = savedSponsor.firstName || "";
      inputs[1].value = savedSponsor.lastName || "";
      inputs[2].value = savedSponsor.address || "";
      inputs[3].value = savedSponsor.city || "";
      inputs[4].value = savedSponsor.zip || "";
    }

    /* country autofill for both sponsor + self */
    const select = form.querySelector("select");

    if (select && savedSponsor.country) {
      const option = select.querySelector(
        `option[data-value="${savedSponsor.country}"]`
      );

      if (option) {
        option.selected = true;
      }
    }
  }

  /* always sponsor first */
  openSponsorStep();

  /* lock steps */
  lockMembershipSteps();
  updateSponsorSidebarStatus();

  setTimeout(() => {
    syncMembershipNavigation();
  }, 300);
});

/* ======================================
   CLICK SPONSOR SIDEBAR
====================================== */
document.addEventListener("click", function (e) {
  if (!isSponsorFlow()) return;

  const sponsorClick = e.target.closest(
    ".sponsor-sidebar-step"
  );

  if (!sponsorClick) return;

  e.preventDefault();

  openSponsorStep();
  lockMembershipSteps();
});

/* ======================================
   SPONSOR FORM SUBMIT
====================================== */
document.addEventListener("submit", function (e) {
  const form = e.target.closest(".sponsor-form form");
  if (!form) return;

  e.preventDefault();

  const inputs = form.querySelectorAll("input");
  const select = form.querySelector("select");

  const countryCode =
    select?.selectedOptions[0]?.getAttribute("data-value");

  let data = {};

  /* SELF FLOW → only country required */
  if (isSelfFlow()) {
    data = {
      country: countryCode
    };

    if (!countryCode) {
      alert("Please select country");
      return;
    }
  }

  /* SPONSOR FLOW → full form required */
  else {
      data = {
      country: countryCode
    };

    if (!countryCode) {
      alert("Please select country");
      return;
    }
//     data = {
//       firstName: inputs[0]?.value.trim(),
//       lastName: inputs[1]?.value.trim(),
//       address: inputs[2]?.value.trim(),
//       city: inputs[3]?.value.trim(),
//       zip: inputs[4]?.value.trim(),
//       country: countryCode
//     };

//    /* Shopify-style stronger validation */

// if (!data.firstName) {
//   alert("Please enter First Name");
//   return;
// }

// if (!data.lastName) {
//   alert("Please enter Last Name");
//   return;
// }

// if (!data.address || data.address.length < 5) {
//   alert("Please enter valid Street Address");
//   return;
// }

// if (!data.city || data.city.length < 2) {
//   alert("Please enter valid City");
//   return;
// }

// if (!data.zip || data.zip.length < 3) {
//   alert("Please enter valid Zip / Postcode");
//   return;
// }

// if (!data.country) {
//   alert("Please select Country");
//   return;
// }

// /* Google autocomplete strict check */
// if (
//   !window.google ||
//   !document.querySelector('.sponsor-form form input')
// ) {
//   alert("Google Address Validation not loaded");
//   return;
// }
  }

  /* save sponsor data */
  // Stamped with the shape version. Older builds of this form stored a full
  // name and address here; those records are still sitting in testers' and
  // customers' localStorage, and the checkout prefill below would happily put
  // that stranger's name on a new order. Anything without the current stamp is
  // ignored for prefill.
  data.v = SPONSOR_DATA_VERSION;

  localStorage.setItem(
    "sponsorData",
    JSON.stringify(data)
  );

  updateSponsorSidebarStatus();

  /* country sync */
  const dropdown = document.querySelector(
    ".ht-tms-single-dropdown__container--region .ht-tms-dropdown__selected"
  );

  const btn = document.querySelector(
    ".ht-tms__duo-selector__button"
  );

  if (dropdown) {
    dropdown.click();

    setTimeout(() => {
      const option = document.querySelector(
        `.ht-tms-option__item[data-value="${countryCode}"]`
      );

      if (option) {
        option.click();

        if (btn) {
          btn.click();
        }
      }
    }, 500);
  }

  /* unlock steps */
  lockMembershipSteps();

  /* open step 1 */
  openMembershipStep(1);
});







// ===============================
// SUBSCRIPTION START DATE HELPERS
// ===============================
// toISOString() converts to UTC first, so for anyone east of UTC an evening
// visit reported tomorrow's date as "today". Every subscription date in this
// flow -- the picker's value, the stepThreeDate key and the
// __uwallet_subscriptions_start / My_Subscription_Date properties -- is a
// calendar date in the shopper's own day, so format from the local parts.
// Output is still YYYY-MM-DD: apex-attribution.js reads these keys, so the
// stored format must not change.
function formatLocalSubscriptionDate(date) {
  return (
    date.getFullYear() +
    "-" +
    String(date.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(date.getDate()).padStart(2, "0")
  );
}

// The picker (flatpickr, dateFormat "Y-m-d") and the stepThreeDate key are kept
// in sync by both change handlers, so either is the shopper's chosen date.
// The picker is preferred because it is what they can actually see.
function getSubscriptionStartDate() {
  var input = document.querySelector(".step-three-date");
  var fromInput = input && input.value ? input.value.trim() : "";
  return fromInput || localStorage.getItem("stepThreeDate") || "";
}

// A future-dated subscription does not charge at this checkout -- it is billed
// on the order that processes it later. That is the same rule
// apex-attribution.js applies to its volume (see COUNT_SUBSCRIPTION_VOLUME),
// so the enrollment overview prices it the same way: FREE today, with the
// recurring amounts shown alongside.
// Both sides are local calendar dates in YYYY-MM-DD, so a string compare is the
// date compare -- no Date parsing, which would reintroduce the UTC shift above.
function subscriptionStartsInFuture() {
  var start = getSubscriptionStartDate();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(start)) return false;
  return start > formatLocalSubscriptionDate(new Date());
}

function productFreeSprayCount(productItem) {
    if (!productItem) return 0;
    const n = parseInt(productItem.getAttribute("data-free-spray-count"), 10);
    return Number.isFinite(n) && n > 0 ? n : 0;
}

function productIsBundleable(productItem) {
    return !!(productItem && productItem.getAttribute("data-bundleable") === "true");
}

function popupNode(popup) {
    if (!popup) return null;
    return popup.jquery ? popup[0] : popup;
}

function popupIsSubscription(popup) {
    const el = popupNode(popup);
    return !!(el && el.getAttribute("data-subscription") === "true");
}

function popupConfiguredCount(popup) {
    const el = popupNode(popup);
    if (!el) return 0;
    const n = parseInt(el.getAttribute("data-free-spray-count"), 10);
    return Number.isFinite(n) && n > 0 ? n : 0;
}

// Subscription products do not carry free_spray_count. Until a parent or the
// popup supplies a count, the existing rule is one spray per unit, at most 3.
const SUBSCRIPTION_SPRAY_CAP = 3;

function popupParents(popup) {
    const el = popupNode(popup);
    const step = el ? el.getAttribute("data-step") || "" : "";
    if (!step) return [];
    return Array.from(document.querySelectorAll(
        `.product-item[gift-true][data-step="${step}"]`
    ));
}

function popupHasConfiguredCount(popup) {
    if (popupConfiguredCount(popup) > 0) return true;
    return popupParents(popup).some((parent) => productFreeSprayCount(parent) > 0);
}

// Parent count wins when it is set, because one popup is shared by every
// parent in the step and those parents can differ. The popup attribute is
// the fallback. 0 means no count is configured.
function effectiveSprayCount(parent, popup) {
    const fromParent = productFreeSprayCount(parent);
    if (fromParent > 0) return fromParent;
    const fromPopup = popupConfiguredCount(popup);
    if (fromPopup > 0) return fromPopup;
    return 0;
}

function effectiveBundleable(parent, popup) {
    if (parent && parent.hasAttribute("data-bundleable")) {
        return parent.getAttribute("data-bundleable") === "true";
    }
    const el = popupNode(popup);
    return !!(el && el.getAttribute("data-bundleable") === "true");
}

function popupSprayAllowance(popup) {
    const el = popupNode(popup);
    if (!el) return 0;
    const parents = popupParents(el);
    const subscription = popupIsSubscription(el);
    const configured = popupHasConfiguredCount(el);
    let total = 0;
    parents.forEach((parent) => {
        const qty = parseInt(parent.querySelector(".quantity__input")?.value, 10) || 0;
        const perUnit = effectiveSprayCount(parent, el);
        if (perUnit > 0) {
            total += qty * perUnit;
        } else if (subscription) {
            total += qty;
        }
    });
    if (subscription && !configured) {
        total = Math.min(total, SUBSCRIPTION_SPRAY_CAP);
    }
    return total;
}

function popupOpenLimit(popup) {
    if (popupIsSubscription(popup) && !popupHasConfiguredCount(popup)) {
        return SUBSCRIPTION_SPRAY_CAP;
    }
    return popupSprayAllowance(popup);
}

function giftConfigFor(giftEl, mainID) {
    const popup = giftEl && giftEl.closest ? giftEl.closest(".gift-popup") : null;
    const parent = mainID
        ? document.querySelector(`.product-item[data-product-id="${mainID}"]`)
        : null;
    return {
        subscription: popupIsSubscription(popup),
        bundleable: effectiveBundleable(parent, popup),
        freeSprayCount: effectiveSprayCount(parent, popup)
    };
}

function giftIsBundleable(gift, parent) {
    if (gift && typeof gift.bundleable === "boolean") return gift.bundleable;
    if (gift && (gift.bundleable === "true" || gift.bundleable === "false")) {
        return gift.bundleable === "true";
    }
    return productIsBundleable(parent);
}

function giftSprayCount(gift, parent) {
    const stamped = parseInt(gift && gift.freeSprayCount, 10);
    if (Number.isFinite(stamped) && stamped > 0) return stamped;
    return productFreeSprayCount(parent);
}

function stepFreeSprayAllowance(step) {
    const popup = document.querySelector(`.gift-popup[data-step="${step}"]`);
    if (popup) return popupSprayAllowance(popup);
    let total = 0;
    document.querySelectorAll(
        `.product-item[gift-true][data-step="${step}"]`
    ).forEach((item) => {
        const qty = parseInt(item.querySelector(".quantity__input")?.value, 10) || 0;
        total += qty * productFreeSprayCount(item);
    });
    return total;
}

function resolveGiftParentProductId(giftEl, storage, giftId) {
    if (storage && giftId) {
        for (const popup of storage.popup_data || []) {
            if (popup.gifts && popup.gifts[giftId] && popup.mainId) {
                return String(popup.mainId);
            }
        }
    }

    const fromGift = giftEl?.getAttribute("data-main-id");
    if (fromGift) return String(fromGift);

    const popup = giftEl?.closest(".gift-popup");
    const step = popup?.getAttribute("data-step") || "";
    const stepSelector = step ? `[data-step="${step}"]` : "";

    const active = document.querySelector(`.product-item[gift-true]${stepSelector}.active`);
    if (active?.getAttribute("data-product-id")) {
        return String(active.getAttribute("data-product-id"));
    }

    const selected = document.querySelectorAll(`.product-item[gift-true]${stepSelector}`);
    const withQty = Array.from(selected).filter((el) => {
        return (parseInt(el.querySelector(".quantity__input")?.value, 10) || 0) > 0;
    });
    const pool = withQty.length ? withQty : selected;
    if (pool.length === 1 && pool[0].getAttribute("data-product-id")) {
        return String(pool[0].getAttribute("data-product-id"));
    }

    return "";
}

// gift_popup_data for code outside the DOMContentLoaded block below, which
// cannot see that block's getGiftStorage.
function readGiftPopupStorage() {
    try {
        return JSON.parse(localStorage.getItem("gift_popup_data")) || { popup_data: [] };
    } catch (e) {
        return { popup_data: [] };
    }
}

// Takes one removed parent's sprays out of its step's popup. The popup has one
// input per spray variant, shared by every parent on that step, so subtract
// only this parent's recorded quantities and leave other parents' picks alone.
// saveStepData rebuilds enrollmentStepData.gifts from these inputs afterwards.
function releaseParentSprays(mainId) {
    const key = String(mainId || "");
    if (!key) return;

    const storage = readGiftPopupStorage();
    const entry = (storage.popup_data || []).find((p) => String(p.mainId) === key);
    if (!entry) return;

    const popup = document.querySelector(`.gift-popup[data-step="${entry.step}"]`);
    Object.keys(entry.gifts || {}).forEach((giftId) => {
        const input = popup?.querySelector(`.gift-item[data-variant-id="${giftId}"] .quantity-input`);
        if (!input) return;
        const taken = parseInt(entry.gifts[giftId], 10) || 0;
        input.value = Math.max((parseInt(input.value, 10) || 0) - taken, 0);
    });

    storage.popup_data = storage.popup_data.filter((p) => String(p.mainId) !== key);
    localStorage.setItem("gift_popup_data", JSON.stringify(storage));
}

// Product ids of the selected spray parents on a step (gift cards with a qty).
function activeSprayParentIds(step) {
    const ids = new Set();
    document.querySelectorAll(`.product-item[gift-true][data-step="${step}"]`).forEach((item) => {
        const id = item.getAttribute("data-product-id");
        const qty = parseInt(item.querySelector(".quantity__input")?.value, 10) || 0;
        if (id && qty > 0) ids.add(String(id));
    });
    return ids;
}

// Spray quantity per variant that the step's parents own in gift_popup_data.
function ownedSprayQty(step) {
    const owned = {};
    readGiftPopupStorage().popup_data
        .filter((p) => p.step === step)
        .forEach((p) => {
            Object.keys(p.gifts || {}).forEach((giftId) => {
                owned[giftId] = (owned[giftId] || 0) + (parseInt(p.gifts[giftId], 10) || 0);
            });
        });
    return owned;
}

// A spray pick must belong to a selected parent. Releases the picks of parents
// no longer selected (e.g. removed with the card's minus button), then caps
// each shared popup input at what the remaining parents own. An unowned pick
// would otherwise be saved with no parent, render in the summary, block the
// popup from reopening and reach the cart. Never adds a spray.
function pruneOrphanSprays() {
    ["one", "two"].forEach((step) => {
        const active = activeSprayParentIds(step);
        readGiftPopupStorage().popup_data
            .filter((p) => p.step === step && !active.has(String(p.mainId)))
            .forEach((p) => releaseParentSprays(p.mainId));

        const owned = ownedSprayQty(step);
        document.querySelectorAll(`.gift-popup[data-step="${step}"] .gift-item`).forEach((giftEl) => {
            const input = giftEl.querySelector(".quantity-input");
            if (!input) return;
            const cap = owned[giftEl.getAttribute("data-variant-id")] || 0;
            if ((parseInt(input.value, 10) || 0) > cap) input.value = cap;
        });
    });
}

// Saved gifts (enrollmentStepData.gifts) held to the same rule.
function ownedSprayGifts(gifts) {
    const active = { one: activeSprayParentIds("one"), two: activeSprayParentIds("two") };
    const owned = { one: ownedSprayQty("one"), two: ownedSprayQty("two") };
    return (gifts || []).filter((gift) => {
        if (!active[gift.step]) return true;
        if (!active[gift.step].has(String(gift.mainID))) return false;
        gift.qty = Math.min(parseInt(gift.qty, 10) || 0, owned[gift.step][gift.id] || 0);
        return gift.qty > 0;
    });
}

// Finish Up spray list for one parent product. updateGiftUI and
// renderFinishStepGift both write sprays here, so they must agree on the list:
// keyed by the parent's product id, reusing an empty unkeyed list (the one the
// section markup ships with) before creating a new one. Top level, not in the
// DOMContentLoaded block below, because updateGiftUI sits outside that block.
function finishStepGiftList(orderSection, mainID) {
    const key = String(mainID || "");
    let list = Array.from(orderSection.querySelectorAll("ul.free.order-list"))
        .find((ul) => (ul.getAttribute("data-main-id") || "") === key);

    if (!list) {
        list = Array.from(orderSection.querySelectorAll("ul.free.order-list"))
            .find((ul) => !ul.getAttribute("data-main-id") && !ul.querySelector("li"));
    }

    if (!list) {
        list = document.createElement("ul");
        list.className = "free order-list";
        list.id = `gift-list-${key}`;
    }

    list.setAttribute("data-main-id", key);
    list.setAttribute("type", "gift");
    placeFinishStepGiftList(orderSection, list);
    return list;
}

// Puts a spray list in the slot collectProductData leaves under the parent row
// whose data-id matches the list's data-main-id. A list whose parent is not
// rendered (yet) waits in the section's free-autoship-product block, and
// collectProductData moves it once the parent row exists.
function placeFinishStepGiftList(orderSection, list) {
    const key = list.getAttribute("data-main-id") || "";
    const slot = key
        ? Array.from(orderSection.querySelectorAll("li.order-list-children"))
            .find((li) => li.getAttribute("data-main-id") === key)
        : null;

    if (slot) {
        if (list.parentElement !== slot) slot.appendChild(list);
        return;
    }
    if (list.isConnected && list.closest(".free-autoship-product")) return;

    let wrapper = orderSection.querySelector(".free-autoship-product");
    if (!wrapper) {
        wrapper = document.createElement("div");
        wrapper.className = "order-inner-2 free-autoship-product";
        const total = orderSection.querySelector(".order-total");
        if (total) {
            total.before(wrapper);
        } else {
            orderSection.appendChild(wrapper);
        }
    }
    wrapper.appendChild(list);
}

document.addEventListener("DOMContentLoaded", function () {
  // ===============================
// STEP 3 DATE LOGIC (TODAY + 30)
// ===============================
const stepThreeDateInput = document.querySelector(".step-three-date");

if (stepThreeDateInput) {
  const formatLocalDate = formatLocalSubscriptionDate;

  // Today (for min)
  const today = new Date();
  const todayFormatted = formatLocalDate(today);

  // Today + 30 days (for default)
  const futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + 30);
  const defaultDate = formatLocalDate(futureDate);

  // 🔓 Allow dates from today
  stepThreeDateInput.setAttribute("min", todayFormatted);

  // ✅ AUTO-SELECT / RESTORE DATE
  const savedDate = localStorage.getItem("stepThreeDate");

  if (savedDate) {
    stepThreeDateInput.value = savedDate;
  } else {
    stepThreeDateInput.value = defaultDate; // 👈 preselect Today + 30
    localStorage.setItem("stepThreeDate", defaultDate);
  }

  // 💾 Save on change
  stepThreeDateInput.addEventListener("change", function () {
    localStorage.setItem("stepThreeDate", this.value);
    // The overview prices step-three as FREE only while the start date is in
    // the future, so moving the date across today has to re-render those lines
    // and re-run the grand total. flatpickr dispatches a native "change" here.
    refreshSubscriptionOrderPricing();
  });
}


    var productSectionsStepOne = document.querySelectorAll(
        ".membership[step-one] .product-list .product-section"
    );
    var membershipStepOne = document.querySelector(".membership[step-one]");
    var membershipStepTwo = document.querySelector(".membership[step-two]");
    var firstLi = document.querySelector(".membership-cart ul li:nth-child(1)");
    var secondLi = document.querySelector(".membership-cart ul li:nth-child(2)");
    var navigation = document.querySelector(".membership-navigation");
    var proceedButton = navigation ? navigation.querySelector(".proceed") : null;
    var productCurrencySymbol = "";
    var productPrice = "";
    var totalPrice = "";
    var stepone_productId = "";
    var selling_plan_ids = "";
    if (firstLi && !isSponsorFlow()) {
    firstLi.classList.add("active");
}

function saveStepData() {
    updateStepCheckedClass();
    let stepData = {
        step: document.querySelector(".membership.active")?.getAttribute("data-index") || 1,
        items: [],
        gifts: []
    };

    // 🔥 SELECT ALL POSSIBLE PRODUCT ITEMS IN ALL STEPS
    const allProducts = document.querySelectorAll(
        `.product-item,
         .product-section,
         .collsecton-data .product-item,
         .product-list .product-item`
    );

    allProducts.forEach((item) => {

        // -----------------------------
        // 🔥 FIX: GET REAL VARIANT ID
        // -----------------------------
       let id =
    item.getAttribute("data-product-id") ||
    item.getAttribute("data-variant-id") ||
    item.getAttribute("data-id");

        if (!id) return; // skip items without id

        // -----------------------------
        // 🔥 FIX: GET STEP NAME
        // -----------------------------
        let step =
            item.getAttribute("data-step") ||
            (item.closest(".membership")?.getAttribute("step-one") && "step-one") ||
            (item.closest(".membership")?.getAttribute("step-two") && "step-two") ||
            (item.closest(".membership")?.getAttribute("step-three") && "step-three");

        if (!step) return;

        // -----------------------------
        // 🔥 FIX: FIND QUANTITY INPUT
        // -----------------------------
        let qtyInput =
            item.querySelector(".quantity__input") ||
            item.querySelector(".cart-quantity input") ||
            item.querySelector("input[data-quantity-variant-id]");

        let qty = parseInt(qtyInput?.value || 0);
        const isGift = item.hasAttribute("gift-true");
        if (qty > 0) {
            stepData.items.push({
                id: id,
                step: step,
                qty: qty,
                type:"main",
                ...(isGift && { gift: true })
            });
        }
    });

    // -----------------------------------
    // 🔥 SAVE GIFTS (this part was okay)
    // -----------------------------------
        // Get storage data
        const storage = JSON.parse(localStorage.getItem("gift_popup_data")) || { popup_data: [] };

        // Loop through gift items
        document.querySelectorAll(".gift-item").forEach((gift) => {
            let qty = parseInt(gift.querySelector(".quantity-input")?.value || 0);
            if (qty > 0) {
                let rawStep = gift.closest(".gift-popup")?.getAttribute("data-step");

                let step =
                    rawStep === "step-one" ? "one" :
                    rawStep === "step-two" ? "two" :
                    rawStep === "step-three" ? "three" :
                    rawStep;

                const giftId = gift.getAttribute("data-variant-id");
                const matchedMainID = resolveGiftParentProductId(gift, storage, giftId);
                const config = giftConfigFor(gift, matchedMainID);

                stepData.gifts.push({
                    id: giftId,
                    mainID: matchedMainID,
                    step: step,
                    qty: qty,
                    type: "gift",
                    subscription: config.subscription,
                    bundleable: config.bundleable,
                    freeSprayCount: config.freeSprayCount
                });
            }
        });

    // -----------------------------------
    // 🔥 SAVE TO LOCAL STORAGE
    // -----------------------------------
    localStorage.setItem("enrollmentStepData", JSON.stringify(stepData));
}

function findProductElementById(id) {
    // Try multiple selector patterns and fallback gracefully
    if (!id && id !== 0) return null;
    id = String(id);
    let selectors = [
        `.product-item[data-id="${id}"]`,
        `.product-item[data-product-id="${id}"]`,
        `.product-item[data-variant-id="${id}"]`,
        `.product-section[data-id="${id}"]`,
        `.product-section[data-product-id="${id}"]`,
        `.product-section[data-variant-id="${id}"]`
    ];
    for (let s of selectors) {
        let el = document.querySelector(s);
        if (el) return el;
    }
    return null;
}

function findQuantityInputForProduct(el) {
    if (!el) return null;
    return (
        el.querySelector(".quantity__input") ||
        el.querySelector(".cart-quantity input") ||
        el.querySelector("input[data-quantity-variant-id]") ||
        el.querySelector("input[type='number']") ||
        null
    );
}

function renderSidebarProduct(id, qty, step) {
    if (!id) return;
    id = String(id);

    const item = findProductElementById(id);
    if (!item) return;

    const title =
        item.getAttribute("data-title") ||
        item.querySelector(".product-title")?.textContent ||
        item.getAttribute("title") ||
        "Product";

    const image =
        item.getAttribute("data-image") ||
        item.querySelector("img")?.src ||
        "";

    // Choose correct step list
    let listSelector = "#step1Products";
    if (step === "two" || step === "step-two" || step == 2) listSelector = "#step2Products";
    if (step === "three" || step === "step-three" || step == 3) listSelector = "#step3Products";

    const list = document.querySelector(listSelector);
    if (!list) return;

    // Remove old slide
    const old = list.querySelector(`.product-slide[data-id="${id}"]`);
    if (old) old.remove();

    // Create slide
    const slide = document.createElement("div");
    slide.className = "product-slide";
    slide.setAttribute("data-id", id);
    slide.setAttribute("data-step", step);

    // ⭐ ADD THESE TWO LINES
    slide.setAttribute("data-title", title);
    slide.setAttribute("data-qty", qty);
    slide.setAttribute("type", "main");

    slide.innerHTML = `
        <div class="step-product-item">
            <span class="remove-icon" title="Remove gift">×</span>
            <img src="${image}" alt="${title}">
            <h3>${qty}x ${title}</h3>
        </div>
    `;


    list.appendChild(slide);
}

function renderSidebarGift(gift) {
    if (!gift || !gift.id) return;

    const id = String(gift.id);
    const qty = gift.qty || 1;
    const step = gift.step || gift.dataStep;
    const mainID = gift.mainID;
    const item = document.querySelector(
        `.gift-item[data-variant-id="${id}"], .gift-item[data-id="${id}"]`
    );
    if (!item) {
        console.warn("renderSidebarGift: gift node not found for id:", id);
        return;
    }

    const title =
        item.getAttribute("data-title") ||
        item.getAttribute("data-name") ||
        item.querySelector(".gift-title")?.textContent ||
        "Gift";

    const image =
        item.getAttribute("data-image") ||
        item.querySelector("img")?.getAttribute("src") ||
        "";

    let list;
    if (step === "two") {
        list = document.querySelector("#step2Products");
    } else if (step === "one") {
        list = document.querySelector("#step1Products");
    } else {
        list = document.querySelector("#step3Products");
    }

    if (!list) {
        console.warn("❌ Carousel list not found for step:", step);
        return;
    }

    // 🔁 Remove old gift if exists
    const old = list.querySelector(`.product-slide[data-id="${id}"]`);
    if (old) old.remove();

    // ✅ Create main card
    const divCard = document.createElement("div");
    divCard.classList.add("product-slide");
    divCard.setAttribute("data-id", id);
    divCard.setAttribute("data-step", step);
    divCard.setAttribute("data-main-id", mainID);
    divCard.setAttribute("type", "gift");

    const innerDiv = document.createElement("div");
    innerDiv.classList.add("step-product-item");

    // ❌ Remove button
    const removeIcon = document.createElement("span");
    removeIcon.classList.add("remove-icon");
    removeIcon.innerHTML = "&times;";
    removeIcon.title = "Remove gift";

    innerDiv.appendChild(removeIcon);

    if (image) {
        const img = document.createElement("img");
        img.src = image;
        img.alt = title;
        innerDiv.appendChild(img);
    }

    const h3 = document.createElement("h3");
    h3.textContent = `${qty}x ${title}`;

    // Included sprays show name and quantity only, no FREE label.
    innerDiv.appendChild(h3);

    divCard.appendChild(innerDiv);
    list.appendChild(divCard);

    console.log("renderSidebarGift: added gift", { id, qty, step });
}

function renderFinishStepGift(gift) {
    if (!gift || !gift.id || !gift.step) return;

    const id = String(gift.id);
    const qty = gift.qty || 1;
    const mainID = gift.mainID || gift.mainProductID || null;

    // 🔁 STEP SWAP LOGIC
    const step =
        gift.step === "two" ? "two" :
        gift.step === "three" ? "three" :
        gift.step;

    const giftItem = document.querySelector(
        `.gift-item[data-variant-id="${id}"], .gift-item[data-id="${id}"]`
    );
    if (!giftItem) return;

    const title =
        giftItem.getAttribute("data-title") ||
        giftItem.getAttribute("data-name") ||
        giftItem.querySelector(".gift-title")?.textContent ||
        "Gift";

    const image =
        giftItem.getAttribute("data-image") ||
        giftItem.querySelector("img")?.src ||
        "";

    const orderSection = document.querySelector(`.order-section.step-${step}`);
    if (!orderSection) return;

    // ✅ FIX data-step ON ORDER SECTION
        orderSection.setAttribute(
        "data-step",
        step === "three" ? "two" :
        step === "two"   ? "three" :
        "one"
        );

    const freeList = finishStepGiftList(orderSection, mainID);

    // One row per spray per parent. Replace rather than skip, so the row
    // carries the current quantity.
    freeList
        .querySelector(`li[data-id="${id}"][data-main-id="${mainID || ""}"]`)
        ?.remove();

    const li = document.createElement("li");
    li.setAttribute("data-id", id);

    // ✅ SWAPPED STEP ON LI
    li.setAttribute(
        "data-step",
        step === "three" ? "two" :
        step === "two"   ? "three" :
        "one"
    );
    li.setAttribute("type", "gift");

    // ✅ MAIN PRODUCT ID ON LI
    li.setAttribute("data-main-id", mainID || "");

    li.innerHTML = `
        <span class="remove-icon" title="Remove gift">×</span>
        <div class="order-list-info">
            ${image ? `<img src="${image}" class="membership-image" />` : ""}
            <span class="order-list-item-qty">${qty}x</span>
            <p>${title}</p>
        </div>
    `;

    freeList.appendChild(li);
}

function restoreStepData() {
    const saved = localStorage.getItem("enrollmentStepData");
    if (!saved) {
        console.log("restoreStepData: no saved data");
        return;
    }

    let data;
    try {
        data = JSON.parse(saved);
    } catch (e) {
        console.error("restoreStepData: invalid JSON in localStorage(enrollmentStepData)", e);
        return;
    }

    console.log("restoreStepData: restoring", data);

    // Restore active step
    const stepIndex = Number(data.step) || data.step;
    document.querySelectorAll(".membership").forEach(m => m.classList.remove("active"));
    const target = document.querySelector(`.membership[data-index="${stepIndex}"]`) || document.querySelector(`.membership[data-index="${String(stepIndex)}"]`);
    if (target) target.classList.add("active");


    document.querySelectorAll(".membership-cart ul li").forEach(li => li.classList.remove("active"));
    if (!isNaN(stepIndex)) {
        const li = document.querySelector(`.membership-cart ul li:nth-child(${stepIndex})`);
        if (li) li.classList.add("active");
    } else {
        const li = Array.from(document.querySelectorAll(".membership-cart ul li"))
            .find(l => l.getAttribute("data-step") === String(stepIndex) || l.textContent.trim().startsWith(String(stepIndex)));
        if (li) li.classList.add("active");
    }


    ["#step1Products", "#step2Products", "#step3Products"].forEach(sel => {
        const el = document.querySelector(sel);
        if (el) el.innerHTML = "";
    });


    if (Array.isArray(data.items)) {
        data.items.forEach((p) => {
            const id = String(p.id);
            const productEl = findProductElementById(id);
            if (productEl) {
                const input = findQuantityInputForProduct(productEl);
                if (input) {
                    input.value = p.qty;
                    input.dispatchEvent(new Event("input", { bubbles: true }));

                    const qtyBox = productEl.querySelector(".quantity-cstm") || productEl.querySelector(".quantity-box");
                    const addBtns = productEl.querySelectorAll("[class*='add-to-cart-step']");

                    if (p.qty > 0) {
                        if (qtyBox) qtyBox.style.display = "block";
                        addBtns.forEach(btn => btn.style.display = "none");
                    } else {
                        if (qtyBox) qtyBox.style.display = "none";
                        addBtns.forEach(btn => btn.style.display = "block");
                    }

                    const stepStr = p.step || productEl.getAttribute("data-step") || productEl.closest(".membership")?.getAttribute("data-index") || "step-two";
                    renderSidebarProduct(id, p.qty, p.step || stepStr);
                } else {
                    console.warn("restoreStepData: quantity input not found for", id);
                }
            } else {
                console.warn("restoreStepData: product not found in DOM for id", id);
                renderSidebarProduct(id, p.qty, p.step || "step-two");
            }
        });
    }

    setTimeout(() => {
        // Parent quantities are restored above. Drop sprays whose parent is
        // gone before anything below renders them, and keep the store in step.
        pruneOrphanSprays();
        if (Array.isArray(data.gifts)) {
            data.gifts = ownedSprayGifts(data.gifts);
            try {
                const current = JSON.parse(localStorage.getItem("enrollmentStepData") || "{}");
                current.gifts = ownedSprayGifts(current.gifts);
                localStorage.setItem("enrollmentStepData", JSON.stringify(current));
            } catch (e) { console.warn("restoreStepData: orphan spray cleanup failed", e); }
        }

        try {
            document.querySelectorAll(".product-item").forEach(el => {
                if (window.jQuery) {
                    try { updateGiftSelectionState(jQuery(el)); } catch(e) { console.warn("updateGiftSelectionState failed", e); }
                }
            });
        } catch (e) { console.warn(e); }

        // Rebuild main product lists
        try { collectProductData("step-one", productDataCard); } catch(e) { console.warn("collectProductData step-one failed", e); }
        try { collectProductData("step-two", productDataContainerOneTime); } catch(e) { console.warn("collectProductData step-two failed", e); }
        try { collectProductData("step-three", productDataContainer); } catch(e) { console.warn("collectProductData step-three failed", e); }

        try { updateGrandTotal(); } catch(e) { console.warn("updateGrandTotal failed", e); }

        // Restore gifts using same logic as main items
        if (Array.isArray(data.gifts)) {
            data.gifts.forEach(gift => {
                const id = String(gift.id);

                // Robust step mapping
                const stepStr =
                    gift.step === "step-one" || gift.step === "one" ? "one" :
                    gift.step === "step-two" || gift.step === "two" ? "two" :
                    gift.step === "step-three" || gift.step === "three" ? "three" :
                    String(gift.step);

                // Optional debug alert
                // alert(`Restoring gift ID: ${id}, Step: ${stepStr}, Qty: ${gift.qty}`);

                const giftEl = document.querySelector(`.gift-popup[data-step="${stepStr}"] .gift-item[data-variant-id="${id}"]`);
                if (giftEl) {
                    const input = giftEl.querySelector(".quantity-input");
                    if (input) {
                        input.value = gift.qty;
                        input.dispatchEvent(new Event("input", { bubbles: true }));

                        const qtyBox = giftEl.querySelector(".quantity-box, .quantity-cstm");
                        const addBtns = giftEl.querySelectorAll("[class*='add-to-cart-step']");
                        if (gift.qty > 0) {
                            if (qtyBox) qtyBox.style.display = "block";
                            addBtns.forEach(btn => btn.style.display = "none");
                        } else {
                            if (qtyBox) qtyBox.style.display = "none";
                            addBtns.forEach(btn => btn.style.display = "block");
                        }

                        renderSidebarGift({ ...gift, step: stepStr });
                    } else {
                        console.warn("restoreStepData: gift quantity input not found for", id);
                        renderSidebarGift({ ...gift, step: stepStr });
                    }
                } else {
                    console.warn("restoreStepData: gift not found in DOM for id", id);
                    renderSidebarGift({ ...gift, step: stepStr });
                }
            });
        }

        // The finish step is rebuilt from the saved gifts below, like the
        // sidebar lists above. Without clearing, rows from earlier passes stay.
        document
            .querySelectorAll('.order-section ul.free.order-list li[type="gift"]')
            .forEach((li) => li.remove());

        if (Array.isArray(data.gifts)) {
            data.gifts.forEach(gift => {
                const stepStr =
                    gift.step === "step-one" || gift.step === "one" ? "one" :

                    // 🔁 SWAP HERE
                    gift.step === "step-two" || gift.step === "two" ? "three" :
                    gift.step === "step-three" || gift.step === "three" ? "two" :

                    null;

                if (!stepStr) return;
                // finish step summary
                renderFinishStepGift({ ...gift, step: stepStr });
            });
        }

        console.log("restoreStepData: finished UI rebuild");

    }, 300);

    updateSkipButtonState(500);

}


/* =====================================================
   Amit-code-09-02-26-top
===================================================== */

const GIFT_STORAGE_KEY = "gift_popup_data";

/* =====================================================
   STORAGE HELPERS
===================================================== */

function getGiftStorage() {
  return JSON.parse(localStorage.getItem(GIFT_STORAGE_KEY)) || { popup_data: [] };
}

function setGiftStorage(data) {
  localStorage.setItem(GIFT_STORAGE_KEY, JSON.stringify(data));
}

/* =====================================================
   GET ACTIVE MAIN PRODUCT
===================================================== */

function getActiveMainProductId($popup) {
  let step = "";
  if ($popup && typeof $popup.attr === "function") {
    step = $popup.attr("data-step") || "";
  } else if ($popup && $popup.getAttribute) {
    step = $popup.getAttribute("data-step") || "";
  }

  const stepSelector = step ? `[data-step="${step}"]` : "";
  const active = document.querySelector(`.product-item[gift-true]${stepSelector}.active`);
  if (active?.getAttribute("data-product-id")) {
    return String(active.getAttribute("data-product-id"));
  }

  const selected = document.querySelectorAll(`.product-item[gift-true]${stepSelector}`);
  const withQty = Array.from(selected).filter((el) => {
    return (parseInt(el.querySelector(".quantity__input")?.value, 10) || 0) > 0;
  });
  const pool = withQty.length ? withQty : selected;
  if (pool.length === 1 && pool[0].getAttribute("data-product-id")) {
    return String(pool[0].getAttribute("data-product-id"));
  }

  return null;
}

/* =====================================================
   SAVE GIFT DATA
===================================================== */

function saveGiftData($popup, giftVariantId, qty) {

  const mainProductId = getActiveMainProductId($popup);
  if (!giftVariantId || !mainProductId) return;

  let rawStep = "";
  if ($popup && typeof $popup.attr === "function") {
    rawStep = $popup.attr("data-step") || "";
  }
  const step =
    rawStep === "step-one" ? "one" :
    rawStep === "step-two" ? "two" :
    rawStep || "two";

  let storage = getGiftStorage();

  if (!storage.popup_data) storage.popup_data = [];

  let productIndex = storage.popup_data.findIndex(
    p => p.mainId === mainProductId
  );

  const config = giftConfigFor(
    popupNode($popup),
    mainProductId
  );

  if (productIndex === -1 && qty > 0) {
    storage.popup_data.push({
      mainId: mainProductId,
      step: step,
      gifts: {},
      subscription: config.subscription,
      bundleable: config.bundleable,
      freeSprayCount: config.freeSprayCount
    });
    productIndex = storage.popup_data.length - 1;
  }

  if (productIndex !== -1) {

    if (qty === 0) {

      delete storage.popup_data[productIndex].gifts[giftVariantId];

      if (Object.keys(storage.popup_data[productIndex].gifts).length === 0) {
        storage.popup_data.splice(productIndex, 1);
      }

    } else {

      storage.popup_data[productIndex].gifts[giftVariantId] = qty;
      storage.popup_data[productIndex].step = step;
      storage.popup_data[productIndex].subscription = config.subscription;
      storage.popup_data[productIndex].bundleable = config.bundleable;
      storage.popup_data[productIndex].freeSprayCount = config.freeSprayCount;

    }
  }

  setGiftStorage(storage);
  console.log("Gift Storage:", storage);

  // stepData only exists inside saveStepData. Checkout rebuilds gifts from
  // the popup inputs on the next click, so there is nothing to clear here.
}

// The later plus/minus handlers live outside this DOMContentLoaded callback.
// They already call saveGiftData after changing the spray quantity.
window.saveGiftData = saveGiftData;

/* =====================================================
   PLUS CLICK
===================================================== */

$(document).on("click", '.gift-item .quantity-btn[name="plus"]', function () {

  const $giftItem = $(this).closest(".gift-item");
  const $popup = $(this).closest(".gift-popup");
  const $input = $giftItem.find(".quantity-input");

  let qty = parseInt($input.val()) || 0;
  qty;
  $input.val(qty);

  const giftVariantId = String($giftItem.data("variant-id"));

  saveGiftData($popup, giftVariantId, qty);
  setTimeout(() => {
          restoreStepData();
  }, 500);
});

/* =====================================================
   MINUS CLICK
===================================================== */

$(document).on("click", '.gift-item .quantity-btn[name="minus"]', function () {

  const $giftItem = $(this).closest(".gift-item");
  const $popup = $(this).closest(".gift-popup");
  const $input = $giftItem.find(".quantity-input");

  let qty = parseInt($input.val()) || 0;

  if (qty > 0) {
    qty;
    $input.val(qty);
  }

  const giftVariantId = String($giftItem.data("variant-id"));

  saveGiftData($popup, giftVariantId, qty);
    setTimeout(() => {
          restoreStepData();
  }, 500);
});

/* =====================================================
   REMOVE MAIN PRODUCT → REMOVE ALL GIFTS
===================================================== */

document.addEventListener("click", function (e) {

  const minusBtn = e.target.closest(
    '.product-item button[name="minus"][type="button"]'
  );

  if (!minusBtn) return;

  const productItem = minusBtn.closest(".product-item");
  if (!productItem || !productItem.hasAttribute("gift-true")) return;

  const quantityInput = productItem.querySelector(".quantity__input");
  if (!quantityInput) return;

  const qty = parseInt(quantityInput.value) || 0;
  if (qty !== 0) return;

  const productID = String(quantityInput.dataset.quantityVariantId);
  if (!productID) return;

  let storage = getGiftStorage();

  storage.popup_data = storage.popup_data.filter(
    p => p.mainId !== productID
  );

  setGiftStorage(storage);

  productItem.classList.remove("active");

  console.log("All gifts removed for product:", productID);
  setTimeout(() => {
          restoreStepData();
  }, 500);
});

/* =====================================================
   REMOVE ICON CLICK (STEP 2 LIST)
===================================================== */
document.getElementById("step2Products").addEventListener("click", function(e) {
  const removeBtn = e.target.closest(".remove-icon");
  if (!removeBtn) return;

  const productSlide = removeBtn.closest(".product-slide");
  if (!productSlide) return;

  const productId = productSlide.dataset.id;
  const type = productSlide.getAttribute("type");
  const step = productSlide.dataset.step;

  // Before reading storage: this drops the parent's popup_data entry.
  if (type === "main") releaseParentSprays(productId);

  let storage = getGiftStorage();

  if (type === "main") {
    // Remove main product & linked gifts
    storage.popup_data = storage.popup_data.filter(p => p.mainId !== productId);
    document.querySelectorAll(`.product-slide[type="gift"][data-main-id="${productId}"]`).forEach(el => el.remove());
    productSlide.remove();
  } else if (type === "gift") {
    storage.popup_data.forEach(p => {
      if (p.gifts && p.gifts[productId]) delete p.gifts[productId];
    });
    storage.popup_data = storage.popup_data.filter(p => Object.keys(p.gifts).length > 0);
    productSlide.remove();
  }

  // Reset gift and main product quantities
  document.querySelectorAll(`.gift-item[data-main-id="${productId}"]`).forEach(gift => {
    const giftQtyInput = gift.querySelector(".quantity__input, .quantity-input, input[type='number']");
    if (giftQtyInput) {
      giftQtyInput.value = 0;
      giftQtyInput.dispatchEvent(new Event("input", { bubbles: true }));
    }

    const giftQtyBox = gift.querySelector(".quantity-cstm, .quantity-box");
    if (giftQtyBox) giftQtyBox.style.display = "none";

    const giftAddBtn = gift.querySelector("[class*='add-to-cart']");
    if (giftAddBtn) giftAddBtn.style.display = "block";
  });

  const mainProduct =
      document.querySelector(`.product-section[data-id="${productId}"]`) ||
      document.querySelector(`.product-item[data-id="${productId}"]`) ||
      document.querySelector(`.product-item[data-product-id="${productId}"]`) ||
      document.querySelector(`.product-item[data-variant-id="${productId}"]`);

  if (mainProduct) {
    const qtyInput = mainProduct.querySelector(".quantity__input, .cart-quantity input, input[data-quantity-variant-id], input[type='number']");
    if (qtyInput) {
      qtyInput.value = 0;
      qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
    }

    const qtyBox = mainProduct.querySelector(".quantity-cstm, .quantity-box");
    if (qtyBox) qtyBox.style.display = "none";

    const addBtn = mainProduct.querySelector("[class*='add-to-cart']");
    if (addBtn) addBtn.style.display = "block";

    mainProduct.classList.remove("active");
  }

  // Update localStorage
  const saved = localStorage.getItem("enrollmentStepData");
  if (saved) {
    let data = JSON.parse(saved);
    data.items = data.items.filter(i => !(String(i.id) === String(productId) && String(i.step) === String(step)));
    localStorage.setItem("enrollmentStepData", JSON.stringify(data));

    setTimeout(() => {
      if (typeof updateGiftCOunt === "function") updateGiftCOunt();
    }, 400);
  }

  // Update totals
  if (typeof window.updateGrandTotal === "function") updateGrandTotal();

  // Save storage
  setGiftStorage(storage);
  setTimeout(() => {
          restoreStepData();
  }, 500);
});



/* =====================================================
   Amit-code-09-02-26-end
===================================================== */







function setupAddToCartAndQuantity(sectionClass, quantityClass) {

    document.querySelectorAll(`.${sectionClass} button`).forEach(function (btn) {
        const newBtn = btn.cloneNode(true);
        btn.replaceWith(newBtn);

        newBtn.addEventListener("click", function () {

            var productSection = newBtn.closest(".product-item");
            if (!productSection) return;

            var quantityBox = productSection.querySelector(`.${quantityClass}.quantity-cstm`);
            var addToCartBtn = productSection.querySelector(`.${sectionClass}`);
            if (!quantityBox) return;

            var quantityInput = quantityBox.querySelector(".quantity__input");
            if (!quantityInput) return;

            if (parseInt(quantityInput.value) < 1) quantityInput.value = 1;

            quantityInput.dispatchEvent(new Event("input", { bubbles: true }));

            if (typeof updateGrandTotal === "function") updateGrandTotal();

            quantityBox.style.display = "block";
            addToCartBtn.style.display = "none";
        });
    });

    /* ===============================
       MINUS BUTTON
    =============================== */
    document
        .querySelectorAll(`.${quantityClass} .quantity__button[name="minus"]`)
        .forEach(function (minusBtn) {

            const newMinusBtn = minusBtn.cloneNode(true);
            minusBtn.replaceWith(newMinusBtn);

            newMinusBtn.removeAttribute("disabled");
            newMinusBtn.classList.remove("disabled");

            newMinusBtn.addEventListener("click", function () {

                const productItem = this.closest(".product-item");
                if (!productItem) return;

                const productID = productItem.getAttribute("data-product-id");
                const step = getStepFromProduct(productItem);

                var quantityBox = this.closest(`.${quantityClass}.quantity-cstm`);
                var productSection = this.closest(".product-item");
                var quantityInput = quantityBox.querySelector(".quantity__input");
                var addToCartBtn = productSection.querySelector(`.${sectionClass}`);

                if (!quantityInput) return;

                let newValue = Math.max(0, (parseInt(quantityInput.value) || 0) - 1);
                quantityInput.value = newValue;
                quantityInput.dispatchEvent(new Event("input", { bubbles: true }));

                if (newValue <= 0) {
                    quantityBox.style.display = "none";
                    if (addToCartBtn) addToCartBtn.style.display = "block";
                    if (step === "one") removeProductFromStepOne(productItem, productID);
                }

                /* ===============================
                   HEL0 (UNCHANGED)
                =============================== */
                if (quantityBox.classList.contains("hel0")) {

    /* 1️⃣ COUNT MAIN QTY */
    let totalMainQty = 0;
    document.querySelectorAll(
        '.product-item[gift-true][data-step="one"]:not(.gift-item) .quantity__input'
    ).forEach(input => {
        totalMainQty += parseInt(input.value) || 0;
    });

    /* 2️⃣ STEP ONE RULE → free sprays per parent unit */
    const maxGiftAllowed = stepFreeSprayAllowance("one");

    let storedData = JSON.parse(localStorage.getItem("enrollmentStepData") || "{}");
    let storedGifts = Array.isArray(storedData.gifts) ? storedData.gifts : [];

    let stepOneGifts = storedGifts.filter(
        g => g.step === "one" && parseInt(g.qty) > 0
    );

    /* 3️⃣ NO MAIN → REMOVE ALL GIFTS */
    if (maxGiftAllowed === 0) {

        document
            .querySelectorAll('.step-product-list .product-slide[type="gift"][data-step="one"]')
            .forEach(el => el.remove());

        storedData.gifts = storedGifts.filter(g => g.step !== "one");
        localStorage.setItem("enrollmentStepData", JSON.stringify(storedData));

        return;
    }

   let remaining = maxGiftAllowed;

stepOneGifts.forEach(gift => {
    if (remaining > 0) {
        const allowed = Math.min(gift.qty, remaining);
        gift.qty = allowed;
        remaining -= allowed;
    } else {
        gift.qty = 0;
    }
});

/* 5️⃣ SYNC POPUP QTY INPUTS */
const giftPopup = document.querySelector('.gift-popup[data-step="one"]');
if (giftPopup) {
    giftPopup.querySelectorAll(".gift-item").forEach(giftItem => {

        const variantId = giftItem.getAttribute("data-variant-id");
        const qtyInput = giftItem.querySelector(".quantity-input");
        if (!qtyInput) return;

        const giftData = stepOneGifts.find(
            g => String(g.id) === String(variantId)
        );

        const newQty = giftData ? giftData.qty : 0;

        qtyInput.value = newQty;
        qtyInput.dispatchEvent(
            new Event("input", { bubbles: true })
        );

        if (newQty === 0) {
            removeGiftSlide(variantId, "one");
        }
    });
}

/* 6️⃣ CLEAN & SAVE LOCALSTORAGE */
storedData.gifts = storedGifts.filter(
    g => g.step !== "one" || g.qty > 0
);

localStorage.setItem(
    "enrollmentStepData",
    JSON.stringify(storedData)
);
}

                /* ===============================
                   HEL1 (FIXED)
                =============================== */
                if (quantityBox.classList.contains("hel1")) {

                    let totalMainQty = 0;
                    document.querySelectorAll(
                        '.product-item[gift-true][data-step="two"]:not(.gift-item) .quantity__input'
                    ).forEach(input => {
                        totalMainQty += parseInt(input.value) || 0;
                    });

                    const maxGiftAllowed = stepFreeSprayAllowance("two");

                    let storedData = JSON.parse(localStorage.getItem("enrollmentStepData") || "{}");
                    let storedGifts = Array.isArray(storedData.gifts) ? storedData.gifts : [];
                    let stepTwoGifts = storedGifts.filter(g => g.step === "two" && parseInt(g.qty) > 0);
                    let validGiftIds = stepTwoGifts.map(g => g.id);

                    /* 🚫 NO MAIN → REMOVE ALL STEP-2 GIFTS */
                    if (maxGiftAllowed === 0) {

                        document
                            .querySelectorAll('.step-product-list .product-slide[type="gift"][data-step="two"]')
                            .forEach(el => el.remove());

                        storedData.gifts = storedGifts.filter(g => g.step !== "two");
                        localStorage.setItem("enrollmentStepData", JSON.stringify(storedData));

                    } else {

                        const giftPopup = document.querySelector(".gift-popup[data-step='two']");
                        if (giftPopup) {
                            let popupStep = "two";
                            let giftItems = giftPopup.querySelectorAll(".gift-item");
                            let remainingQty = maxGiftAllowed;
                            let totalGifts = stepTwoGifts.length;

                            giftItems.forEach((giftItem, index) => {

                                let qtyInput = giftItem.querySelector(".quantity-input");
                                if (!qtyInput) return;

                                let variantId = giftItem.getAttribute("data-variant-id");

                                if (!validGiftIds.includes(variantId)) {
                                    qtyInput.value = 0;
                                } else {
                                    let baseQty = Math.floor(remainingQty / totalGifts);
                                    let extra = remainingQty % totalGifts;
                                    qtyInput.value = baseQty + (index < extra ? 1 : 0);
                                    remainingQty -= qtyInput.value;
                                    totalGifts--;
                                }

                                if (parseInt(qtyInput.value) === 0) {
                                    removeGiftSlide(variantId, popupStep);
                                }
                            });
                        }
                    }
                }

                if (typeof updateGrandTotal === "function") updateGrandTotal();

                removeProductIfQuantityZero(productItem, productID, newValue);
            });
        });
}

/* ===============================
   REMOVE GIFT SLIDE (SAFE)
=============================== */
function removeGiftSlide(variantId, popupStep) {

  /* ---------------------------
     1️⃣ REMOVE SLIDE IF NEEDED
  ----------------------------*/
  document
    .querySelectorAll('.step-product-list .product-slide[type="gift"]')
    .forEach(slide => {
      const slideId =
        slide.getAttribute("data-id") ||
        slide.getAttribute("data-variant-id");

      if (String(slideId) === String(variantId)) {
        slide.remove();
      }
    });

  /* ---------------------------
     2️⃣ UPDATE SLIDER TITLES (qty + title)
  ----------------------------*/
  setTimeout(() => {
    const storedData = JSON.parse(localStorage.getItem("enrollmentStepData") || "{}");
    if (!storedData.gifts || !Array.isArray(storedData.gifts)) return;

    // STEP-PRODUCT-LIST
    document
      .querySelectorAll('.step-product-list .product-slide[type="gift"]')
      .forEach(slide => {

        const slideId = slide.getAttribute("data-id");
        if (!slideId) return;

        const giftData = storedData.gifts.find(
          g => String(g.id) === String(slideId)
        );
        if (!giftData) return;

        const qty = giftData.qty || 1;
        const h3 = slide.querySelector("h3");
        const img = slide.querySelector("img");
        if (!h3 || !img) return;

        const title = img.getAttribute("alt") || "";
        h3.textContent = `${qty}x ${title}`;
      });

    /* ---------------------------
       3️⃣ UPDATE ORDER SUMMARY (STEP THREE)
    ----------------------------*/
    document
      .querySelectorAll(`.order-section[data-step="${popupStep}"] .order-list li[data-id]`)
      .forEach(li => {

        const liId = li.getAttribute("data-id");
        if (!liId) return;

        const giftData = storedData.gifts.find(
          g => String(g.id) === String(liId)
        );
        if (!giftData) return;

        const qty = giftData.qty || 1;

        const qtyEl = li.querySelector(".order-list-item-qty");
        const img = li.querySelector("img");
        const titleEl = li.querySelector("p");

        if (qtyEl) qtyEl.textContent = `${qty}x`;
        if (img && titleEl) {
          const title = img.getAttribute("alt") || titleEl.textContent;
          titleEl.textContent = title;
        }
      });

  }, 500);

  $(`.order-section[data-step="${popupStep}"] .order-list li[data-id="${variantId}"]`).remove();
}


    setupAddToCartAndQuantity("add-to-cart-step-0", "hel0");
    setupAddToCartAndQuantity("add-to-cart-step-1", "hel1");
    setupAddToCartAndQuantity("add-to-cart-step-2", "hel2");

    var membershipCard = document.querySelector(".membership-card");
    var membershipContainer = document.querySelector(".monthly-autoship-product");
    var oneTimeShipContainer = document.querySelector(".one-time-product");
    var productDataCard = createListContainer( "membership-card-data-container");
    var productDataContainer = createListContainer( "monthly-autoship-product-data-container");
    var productDataContainerOneTime = createListContainer("one-time-product-data-container");

    membershipCard.appendChild(productDataCard);
    membershipContainer.appendChild(productDataContainer);
    oneTimeShipContainer.appendChild(productDataContainerOneTime);
    function createListContainer(className) {
        var container = document.createElement("ul");
        container.classList.add(className, "order-list");
        return container;
    }
function removeProductFromStepOne(productItem, variantID) {
    if (!variantID) {
        console.warn("❌ Step-One remove failed: missing variantID");
        return;
    }

    console.log("🧹 STEP-ONE REMOVE → Variant ID:", variantID);

    /* ---------------- MAIN PRODUCT REMOVE ---------------- */
    document
        .querySelectorAll(`.product-slide[data-id="${variantID}"]`)
        .forEach(slide => {
            slide.remove();
            console.log("🗑 Step-One sidebar product removed:", variantID);
        });

    /* ---------------- LINKED GIFTS REMOVE ---------------- */
    document
        .querySelectorAll(`.product-slide[data-main-id="${variantID}"]`)
        .forEach(gift => {
            gift.remove();
            console.log("🎁 Step-One linked gift removed for:", variantID);
        });

    /* ---------------- SAVE + RECALC ---------------- */
    saveStepData();

    setTimeout(() => {
        if (typeof updateGiftCOunt === "function") {
            updateGiftCOunt();
        }
    }, 300);
}

    function collectProductData(step, container) {
        console.log(step,"collectProductDatacollectProductData")
        var productSections = document.querySelectorAll(`.membership[${step}] .collsecton-data .product-item`
        );
        var productDataArray = [];
        // Spray lists sit in slots inside this list. Keep them across the
        // rebuild below; they are put back under their parents at the end.
        var orderSection = container.closest(".order-section");
        var keptGiftLists = Array.from(container.querySelectorAll("ul.free.order-list"));
        container.innerHTML = "";
        if (orderSection) {
            keptGiftLists.forEach(function (list) {
                placeFinishStepGiftList(orderSection, list);
            });
        }
        var subtotal = 0;
        //var subtotalContainer = document.querySelector(`.membership .${step} .order-total` );
        let subtotalContainer = document.querySelector(`.membership .${step} .order-total`);
        if (subtotalContainer) subtotalContainer.innerHTML = "";
        // Step three is the recurring subscription order. Started in the
        // future it is billed on a later order, not this checkout, so it is
        // priced at zero here and its real amounts are shown as "Monthly".
        var subscriptionIsDeferred =
            step === "step-three" && subscriptionStartsInFuture();
        productSections.forEach((product) => {
            var valdata = product.querySelector(".cart-quantity input").value; // Get the value

            var proceedButton = document.querySelector(".proceed"); // Select the button once
            if (parseInt(valdata) >= 1) {
                product.classList.add("enablebtn");
            } else {
                product.classList.remove("enablebtn");
                product.classList.remove("active");
                
            }

            var productQuantity =
                parseInt(product.querySelector(".quantity__input").value, 10) || 0;
            if (productQuantity > 0) {
                var productData = {
                    id: product.getAttribute("data-product-id"),
                    title: product.getAttribute("data-title"),
                    image: product.getAttribute("data-image"),
                    price: parseFloat(
                    (product.getAttribute("data-price") || "0").replace(/,/g, "")
                    ) || 0,
                    currencySymbol: product.getAttribute("data-currency-symbol"),
                    subscriptionsName: product.getAttribute("data-selling-name"),
                    bv: parseFloat(product.getAttribute("data-bv-meta")) || 0,
                    quantity: productQuantity,
                };
                totalPrice = productData.price * productQuantity;
                subtotal += totalPrice;

                // Monthly BV is shown on step-three only -- that step is the
                // recurring subscription order, so its volume is what the rep
                // earns each time the subscription runs. Steps one and two are
                // this order's own volume and already counted in Total BV, so
                // labelling them "Monthly" would be wrong.
                var monthlyBvMarkup = "";
                if (step === "step-three" && productData.bv > 0) {
                    // Whole-number BV, truncated like apex-attribution.js.
                    var lineBv = Math.trunc(Math.round((productData.bv * productQuantity) * 1e6) / 1e6);
                    monthlyBvMarkup =
                        '<span class="order-list-item-bv">Monthly BV: ' +
                        lineBv +
                        "</span>";
                }

                // Nothing is charged today for a future-dated subscription, so
                // the line shows no amount and carries the recurring price
                // instead. Per unit, so it reads as the product's own monthly
                // price. Subtotals below are unchanged.
                var monthlyPriceMarkup = "";
                var lineAmountMarkup =
                    "<span>" +
                    productData.currencySymbol +
                    totalPrice.toFixed(2) +
                    "</span>";
                if (subscriptionIsDeferred) {
                    monthlyPriceMarkup =
                        '<span class="order-list-item-monthly-price">Monthly Price: ' +
                        productData.currencySymbol +
                        productData.price.toFixed(2) +
                        "</span>";
                    lineAmountMarkup = "";
                }

                productDataArray.push(productData);
                container.innerHTML += `
                <li data-id="${productData.id}">
                    <div class="order-list-info">
                        <img src="${productData.image}" alt="${productData.title
                    }" class="membership-image">
                        <span class="order-list-item-qty" data-pty="${productQuantity}">${productQuantity}x</span>
                        <p>${productData.title}${monthlyPriceMarkup}${monthlyBvMarkup}</p>
                    </div>
                    ${lineAmountMarkup}
                </li>
            `;
            }
        });

        // One slot under each parent row, keyed by the same product id that
        // the parent's sprays carry as data-main-id, then move every spray
        // list in this section into its parent's slot.
        Array.from(container.children).forEach(function (row) {
            var productId = row.getAttribute("data-id");
            if (!productId) return;
            var slot = document.createElement("li");
            slot.className = "order-list-children";
            slot.setAttribute("data-main-id", productId);
            row.after(slot);
        });
        if (orderSection) {
            orderSection.querySelectorAll("ul.free.order-list[data-main-id]").forEach(function (list) {
                placeFinishStepGiftList(orderSection, list);
            });
        }

        var data = $(".product-item").hasClass("enablebtn");
        if (data == true) {
            $(".membership-navigation button.proceed").removeClass("disabled");
            $(".membership-navigation button.proceed").removeClass("disabled");
        } else {
            $(".membership-navigation button.proceed").addClass("disabled");
        }

        // Update subtotal container if found
        if (subtotalContainer) {
            // updateGrandTotal() reads .subtotal-<step> back out of the DOM, so
            // zeroing it here is what keeps the subscription out of the
            // enrollment total the shopper is charged today.
            var chargedToday = subscriptionIsDeferred ? 0 : subtotal;
            // Suppressed at zero: an empty subscription section has no monthly
            // amount to state, and "Monthly total: $0.00" only adds noise.
            var monthlyTotalMarkup =
                subscriptionIsDeferred && subtotal > 0
                    ? `<span class="monthly-subtotal">Monthly total: ${productCurrencySymbol}${subtotal.toFixed(2)}</span>`
                    : "";
            subtotalContainer.innerHTML = `
            <span class="subtotal subtotal-${step}">${productCurrencySymbol}${chargedToday.toFixed(2)}</span>
            ${monthlyTotalMarkup}
            <span class="subscriptionsName">${productDataArray.map((p) => p.subscriptionsName).join(" ")}</span>`;
        }

        console.log(
            "productDataArray JSON:",
            JSON.stringify(productDataArray, null, 2)
        );

        updateSkipButtonState();

        return productDataArray;

        const skipBtn = document.querySelector(".skip-button");

        if (skipBtn) {
            if (productDataArray.length === 0) {
                skipBtn.classList.remove("hide_button");
            } else {
                skipBtn.classList.add("hide_button");
            }
        }

    }

    document.addEventListener("input", function (event) {
        var productItem = event.target.closest(".collsecton-data .product-item");
        if (!productItem) return;

        var step = productItem.closest(".membership[step-one]") ? "step-one"
         : productItem.closest(".membership[step-two]") ? "step-two"
         : productItem.closest(".membership[step-three]") ? "step-three"
         : null;

        if (step) {
          const container = step === "step-one" ? productDataCard
                          : step === "step-two" ? productDataContainerOneTime
                          : productDataContainer; // step-three
          collectProductData(step, container);
        }
        updateGrandTotal();
    });

    document.addEventListener("click", function (event) {
        var button = event.target.closest(".quantity__button");
        if (!button) return;
        var quantityInput = button
            .closest(".quantity")
            .querySelector(".quantity__input");
        quantityInput.value =
            button.name === "plus"
                ? parseInt(quantityInput.value, 10)
                : Math.max(0, parseInt(quantityInput.value, 10));


        var productItem = button.closest(".collsecton-data .product-item[gift-true]");
        if (!productItem) return;

        if (button.name === "plus") {
            document.querySelectorAll(".product-item[gift-true]").forEach((el) => {
                el.classList.remove("active");
            });
            productItem.classList.add("active");
            console.log("plus");
            setTimeout(() => {
                syncStepThreeGiftPopup(productItem);
            }, 500);
        }

        var step = productItem.closest(".membership[step-one]") ? "step-one"
                : productItem.closest(".membership[step-two]") ? "step-two"
                : productItem.closest(".membership[step-three]") ? "step-three"
                : null;

        if (step) {
            const container = step === "step-one" ? productDataCard
                            : step === "step-two" ? productDataContainerOneTime
                            : productDataContainer; // step-three
            collectProductData(step, container);
        }
        updateGrandTotal();
    });

    // Re-price the subscription section after the start date moves. Declared
    // here so it closes over collectProductData/productDataContainer; it is
    // hoisted, so the date picker's change handler above can call it.
    function refreshSubscriptionOrderPricing() {
        if (!productDataContainer) return;
        collectProductData("step-three", productDataContainer);
        updateGrandTotal();
    }

    function updateGrandTotal() {
        var stepOneSubtotal =
            parseFloat(
                document
                    .querySelector(".subtotal-step-one")
                    ?.textContent.replace(/[^0-9.]/g, "")
            ) || 0;
        var stepTwoSubtotal =
            parseFloat(
                document
                    .querySelector(".subtotal-step-two")
                    ?.textContent.replace(/[^0-9.]/g, "")
            ) || 0;
        var stepThreeSubtotal =
            parseFloat(
                document
                    .querySelector(".subtotal-step-three")
                    ?.textContent.replace(/[^0-9.]/g, "")
            ) || 0;
        var productPrice =
            parseFloat(
                document
                    .querySelector(".discounted-price")
                    ?.textContent.replace(/[^0-9.]/g, "")
            ) || 0;

        var grandTotal = stepOneSubtotal + stepTwoSubtotal + stepThreeSubtotal + productPrice;

        var grandTotalContainers = document.querySelectorAll(".GrandTotal");

        grandTotalContainers.forEach((container) => {
            container.innerHTML = `<strong>${productCurrencySymbol}${grandTotal.toFixed(
                2
            )}</strong>`;
        });
    }

// Single-flight guard for the enrollment submit. Both .checkout-btn buttons
// share this handler and the submit runs for several seconds, so a second click
// would post the same items again and Shopify would merge the lines, doubling
// every quantity (CILI#2904). Released on every abort path; held on success
// while we navigate to /checkout.
var apexEnrollmentSubmitInFlight = false;

// Visual half of the same guard. The submit runs for several seconds (cart
// clear -> cart add -> apex metafield write -> attribute write) and nothing on
// screen changes until the redirect, so the button reads as dead and people
// click it again. Grey it out and spin the moment the submit starts, on both
// .checkout-btn buttons -- they submit the same enrollment, so neither should
// stay live while one is running.
function setEnrollmentSubmitPending() {
  document.querySelectorAll(".checkout-btn").forEach(function (btn) {
    if (btn.classList.contains("is-submitting")) return;
    btn.dataset.idleLabel = btn.innerHTML;
    btn.classList.add("is-submitting");
    btn.setAttribute("aria-busy", "true");
    btn.disabled = true;
    btn.innerHTML =
      '<span class="checkout-btn__spinner" aria-hidden="true"></span>' +
      '<span class="checkout-btn__label">Processing\u2026</span>';
  });
}

function clearEnrollmentSubmitPending() {
  document.querySelectorAll(".checkout-btn.is-submitting").forEach(function (btn) {
    btn.classList.remove("is-submitting");
    btn.removeAttribute("aria-busy");
    btn.disabled = false;
    if (btn.dataset.idleLabel !== undefined) {
      btn.innerHTML = btn.dataset.idleLabel;
      delete btn.dataset.idleLabel;
    }
  });
  // custom.js re-asserts the real enabled/disabled state on its next 300ms
  // tick; it skips .is-submitting buttons so it can't undo the state above.
}

function releaseEnrollmentSubmitLock() {
  apexEnrollmentSubmitInFlight = false;
  clearEnrollmentSubmitPending();
}

// bfcache can restore this page with the lock still held, leaving the button
// dead after checkout -> Back. Reset it on restore.
window.addEventListener("pageshow", function (event) {
  if (event.persisted) releaseEnrollmentSubmitLock();
});

document.querySelectorAll(".checkout-btn").forEach(function (button) {
  var onEnrollmentCheckoutClick = async function (event) {
    event.preventDefault();

    if (apexEnrollmentSubmitInFlight) {
      console.warn("Enrollment submit already in progress — ignoring duplicate click.");
      return;
    }
    apexEnrollmentSubmitInFlight = true;
    setEnrollmentSubmitPending();

    // Enrollment owns the cart from here on. This must be set BEFORE the first
    // cart mutation below: apex-cart-volume.js wraps window.fetch and arms a
    // debounced (250ms) background recompute after every
    // /cart/(add|change|update|clear). /cart/add.js routinely takes longer than
    // that, so the recompute armed by /cart/clear.js used to fire mid-submit and
    // spend three extra requests (GET /cart.js + volume query + cartMetafieldsSet)
    // on a half-built cart, racing our own write. Every abort path clears it
    // again via releaseEnrollmentSubmitLock().
    window.__APEX_SKIP_AUTO_SYNC__ = true;

    /* 🔥 check sponsor/self flow first */
    const enrollmentType = localStorage.getItem("enrollment_type");
    const sponsorData = localStorage.getItem("sponsorData");

    if (
      (enrollmentType === "self" || enrollmentType === "sponsor") &&
      !sponsorData
    ) {
      releaseEnrollmentSubmitLock();
      alert("Please fill Step 1 Sponsor Form first");
      openSponsorStep();
      lockMembershipSteps();
      return;
    }

    const step1ProductCount =
      document.querySelectorAll("#step1Products .product-slide").length;

    if (step1ProductCount <= 0) {
      alert("You must keep at least one pack");
      releaseEnrollmentSubmitLock();
      return;
    }

    var memberInput = button.closest("form")?.querySelector('input[name="CILIMember"]');
    var member_name = memberInput?.value?.trim() || "";
    var member_id = "";
    var member_handle = "";

    const selectedRepData = localStorage.getItem("selectedRep");
    if (selectedRepData) {
      try {
        const rep = JSON.parse(selectedRepData);
        // Keyed on rep_# — a rep with only one name part is still a sponsor.
        if (rep["rep_#"]) {
          member_name =
            [rep.first_name, rep.last_name].map((n) => (n || "").trim()).filter(Boolean).join(" ") ||
            member_name;
          member_id = rep["rep_#"];
          member_handle = rep.handle || "";
        }
      } catch (e) {
        console.error("Error parsing selectedRep:", e);
      }
    }

    let totalRV = 0;
    let totalBV = 0;
    let totalWV = 0;

    const stepThreeDate = localStorage.getItem("stepThreeDate") || "";
    var itemsToAdd = [];

    // ✅ Load saved gifts from localStorage once
    let savedGifts = [];
    const savedData = localStorage.getItem("enrollmentStepData");
    if (savedData) {
      try {
        const parsed = JSON.parse(savedData);
        if (Array.isArray(parsed.gifts)) savedGifts = parsed.gifts;
      } catch (e) {
        console.error("Gift restore failed", e);
      }
    }

    const addedGiftIds = new Set();

    // step on a gift is the wizard id only. Subscription line properties come
    // from gift.subscription, which was copied from the popup, or from the
    // parent being a step-three subscription product. Before PR #27 every
    // spray carried them; sprays under a subscription parent still need them
    // even when the popup's subscription metafield is not set.
    function giftCartProperties(gift, parentIsSubscription) {
      var properties = { "_Free Gift": "Yes" };
      if (parentIsSubscription || gift.subscription === true || gift.subscription === "true") {
        properties.__uwallet_subscriptions_base_product = gift.mainID || "";
        properties.My_Subscription_Date = stepThreeDate;
        properties.__uwallet_subscriptions_start = stepThreeDate;
      }
      return properties;
    }

    // One token per bundleable parent unit. The product id is shared by every
    // unit of the same product, so it cannot be the group id.
    function createPackGroupToken() {
      if (window.crypto && typeof window.crypto.randomUUID === "function") {
        return window.crypto.randomUUID();
      }
      return "pack-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 12);
    }

    // The free membership is one per enrollment, not one per pack. Every
    // qualifying product carries the same custom.free_membership metafield, so
    // without this the variant was pushed once per selected pack -- and because
    // each copy carried a different "_Triggered By", Shopify could not merge
    // them and the order showed the subscription twice.
    const addedFreeMembershipIds = new Set();
    // Cart-level subscription dates belong to a selected monthly subscription
    // product only. The automatic 12-Month CILI Membership is a free-membership
    // line, not a step-three product, so it must not set this.
    var hasStepThreeSubscription = false;

    // ✅ BUILD: for each product → main product → free membership → its gifts.
    // The list is reversed when posted to /cart/add.js (see there).
    // Checkout order is Pack (step-one), Subscription (step-three), then
    // Additional one-time products (step-two).
    ["step-one", "step-three", "step-two"].forEach((step) => {
      document
        .querySelectorAll(`.membership[${step}] .collsecton-data .product-item`)
        .forEach((product) => {
          const quantity = parseInt(product.querySelector(".quantity__input")?.value || 0);
          const variantId = parseInt(product.getAttribute("data-id"), 10);
          const productId = product.getAttribute("data-product-id"); // ✅ for gift matching
          const sellingIdRaw = product.getAttribute("data-selling-ids");
          const freeMembershipVariant = product.getAttribute("data-free-membership");

          if (!variantId || quantity <= 0) return;

          if (step === "step-three") hasStepThreeSubscription = true;

          const sellingId =
            sellingIdRaw && !isNaN(parseInt(sellingIdRaw)) ? parseInt(sellingIdRaw) : null;

          const rv = parseFloat(product.getAttribute("data-rv-meta")) || 0;
          const bv = parseFloat(product.getAttribute("data-bv-meta")) || 0;
          const wv = parseFloat(product.getAttribute("data-wv-meta")) || 0;

          // Total RV/BV/WV represent this order's own volume, not future
          // subscription volume — step-three products are excluded, matching
          // apex-attribution.js's COUNT_SUBSCRIPTION_VOLUME handling of the
          // same future-dated lines.
          if (step !== "step-three") {
            totalRV += rv * quantity;
            // BV is truncated per line, matching apex-attribution.js.
            totalBV += Math.trunc(Math.round((bv * quantity) * 1e6) / 1e6);
            totalWV += wv * quantity;
          }

          let properties = {
            "_Retail Volume": rv,
            "Business Volume": Math.trunc(Math.round((bv * quantity) * 1e6) / 1e6),
            "_Wholesale Volume": wv,
          };

          if (step === "step-three" && stepThreeDate) {
            properties["__uwallet_subscriptions_start"] = stepThreeDate;
            properties["My_Subscription_Date"] = stepThreeDate;
          }

          // Pack grouping follows the saved gift's bundleable flag and count.
          // Those were copied from the parent card, with the popup as fallback.
          // A missing stamp still reads the parent card so an in-progress
          // selection keeps the current pack behavior.
          const parentPopup = document.querySelector(
            `.gift-popup[data-step="${product.getAttribute("data-step")}"]`
          );
          const matchedForParent = savedGifts.filter((gift) => {
            return gift.id && gift.qty > 0 && String(gift.mainID) === String(productId);
          });
          const sampleGift = matchedForParent[0];
          const bundleable = sampleGift
            ? giftIsBundleable(sampleGift, product)
            : effectiveBundleable(product, parentPopup);
          const spraysPerUnit = sampleGift
            ? giftSprayCount(sampleGift, product)
            : effectiveSprayCount(product, parentPopup);
          const parentIsSubscription = step === "step-three";
          const packSprayGifts = [];
          const productGifts = [];
          savedGifts.forEach((gift) => {
            if (!gift.id || gift.qty <= 0) return;
            if (String(gift.mainID) !== String(productId)) return;
            // Keyed by spray + product: the same spray can be earned by two.
            const giftKey = `${gift.id}|${gift.mainID}`;
            if (addedGiftIds.has(giftKey)) return;

            addedGiftIds.add(giftKey);

            if (bundleable && spraysPerUnit > 0) {
              packSprayGifts.push(gift);
              return;
            }

            productGifts.push({
              id: parseInt(gift.id, 10),
              quantity: gift.qty,
              properties: giftCartProperties(gift, parentIsSubscription),
            });
          });

          // Lines after the main product: leftover pack sprays, or this
          // product's non-pack gifts (subscription etc., one line each).
          let trailingGiftLines = productGifts;

          if (packSprayGifts.length > 0) {
            const sprayUnits = [];
            packSprayGifts.forEach((gift) => {
              const sprayQty = parseInt(gift.qty, 10) || 0;
              for (let unit = 0; unit < sprayQty; unit++) sprayUnits.push(gift);
            });

            for (let instance = 0; instance < quantity; instance++) {
              const packGroup = createPackGroupToken();
              const pair = sprayUnits.slice(
                instance * spraysPerUnit,
                instance * spraysPerUnit + spraysPerUnit
              );
              const sprayLines = [];

              pair.forEach((gift) => {
                const sprayVariantId = parseInt(gift.id, 10);
                const existing = sprayLines.find((line) => line.id === sprayVariantId);
                if (existing) {
                  existing.quantity += 1;
                  return;
                }

                const sprayProperties = giftCartProperties(gift, parentIsSubscription);
                sprayProperties["_pack_group"] = packGroup;
                sprayProperties["_pack_parent"] = String(gift.mainID || productId);
                sprayLines.push({
                  id: sprayVariantId,
                  quantity: 1,
                  properties: sprayProperties,
                });
              });

              // Pack unit first, then the sprays in its group.
              const packProperties = Object.assign({}, properties);
              packProperties["_pack_group"] = packGroup;
              itemsToAdd.push({
                id: variantId,
                quantity: 1,
                properties: packProperties,
                ...(sellingId !== null && { selling_plan: sellingId }),
              });

              sprayLines.forEach((line) => itemsToAdd.push(line));
            }

            const assignedUnits = quantity * spraysPerUnit;
            const leftoverLines = [];
            sprayUnits.slice(assignedUnits).forEach((gift) => {
              const sprayVariantId = parseInt(gift.id, 10);
              const existing = leftoverLines.find((line) => line.id === sprayVariantId);
              if (existing) {
                existing.quantity += 1;
                return;
              }
              leftoverLines.push({
                id: sprayVariantId,
                quantity: 1,
                properties: giftCartProperties(gift, parentIsSubscription),
              });
            });
            trailingGiftLines = leftoverLines;
          } else {
            // ✅ main product
            itemsToAdd.push({
              id: variantId,
              quantity: quantity,
              properties: properties,
              ...(sellingId !== null && { selling_plan: sellingId }),
            });
          }

          // ✅ free membership after main
          if (freeMembershipVariant && !addedFreeMembershipIds.has(String(freeMembershipVariant))) {
            addedFreeMembershipIds.add(String(freeMembershipVariant));
            itemsToAdd.push({
              id: parseInt(freeMembershipVariant, 10),
              quantity: 1,
              properties: {
                "_Free Product": "Applied Automatically",
                "_Triggered By": `Product ${variantId}`,
              },
            });
          }

          // ✅ gifts after main (only for products that have gifts)
          trailingGiftLines.forEach((line) => itemsToAdd.push(line));
        });
    });

    // ✅ Fallback: gifts not matched to any product above
    savedGifts.forEach((gift) => {
      if (!gift.id || gift.qty <= 0) return;
      const giftKey = `${gift.id}|${gift.mainID}`;
      if (addedGiftIds.has(giftKey)) return;

      addedGiftIds.add(giftKey);
      itemsToAdd.push({
        id: parseInt(gift.id, 10),
        quantity: gift.qty,
        properties: giftCartProperties(gift),
      });
    });

    if (itemsToAdd.length === 0) {
      alert("No valid items selected.");
      releaseEnrollmentSubmitLock();
      return;
    }

    console.log("ITEMS:", itemsToAdd);

    // Enrollment must submit against an isolated, empty cart — clear any
    // leftover items from a previous enrollment attempt first, and abort
    // instead of adding on top of a cart that failed to clear (that would
    // produce incorrect quantities/volumes at checkout).
    try {
      var clearResponse = await fetch("/cart/clear.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      if (!clearResponse.ok) {
        console.error("❌ Cart clear failed before enrollment submit:", clearResponse.status);
        alert("Could not prepare your cart for checkout. Please try again.");
        releaseEnrollmentSubmitLock();
        return;
      }
    } catch (e) {
      console.error("❌ Cart clear failed before enrollment submit:", e);
      alert("Could not prepare your cart for checkout. Please try again.");
      releaseEnrollmentSubmitLock();
      return;
    }

    var cartAttributes = {
      //   CILIMember: member_id,
      orderFrom: "enrollment",
      "Total RV": totalRV.toFixed(2),
      "Total BV": String(totalBV),
      "Total WV": totalWV.toFixed(2),
    };
    // Whoever is selected now is the sponsor of record — the sponsor_id
    // attribute cart-attributes.liquid wrote on page load may predate a change.
    const attrType = currentEnrollmentType();
    const manualPick = localStorage.getItem("manualMemberSelected") === "true";
    if (member_id && (attrType === "sponsor" || (attrType === "" && manualPick))) {
      cartAttributes.sponsor_id = member_name + " (" + member_id + ")";

      // A sponsor picked from the dropdown replaces the landing link's values,
      // which were already written to the cart on page load. Blank clears them;
      // a no-type pick is a lookup, so it has no referral handle.
      if (manualPick) {
        cartAttributes.retail_web_site_name = attrType === "sponsor" ? member_handle : "";
        cartAttributes.CILIKey = "";
      }
    }
    if (hasStepThreeSubscription) {
      cartAttributes.__uwallet_subscriptions_start = stepThreeDate;
      cartAttributes.My_Subscription_Date = stepThreeDate;
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        // Shopify lists lines from a multi-item add in reverse, so the
        // reversed post lands in the cart as built: pack, subscription,
        // one-time, each parent above its own sprays (86a392f).
        items: itemsToAdd.slice().reverse(),
        attributes: cartAttributes,
      }),
    })
    .then(async (response) => {
      const data = await response.json();
      if (!response.ok) {
        console.error("❌ Shopify Cart Error:", data);
        alert("Cannot find variant.\n\nCheck console → failing variant is logged.");
        throw data;
      }
      return data;
    })
    .then(async () => {
      // Push the enrollment's attribution values into the cart metafields on
      // the current cart token, before we navigate to /checkout.
      // member_id/member_name
      // (resolved above from localStorage.selectedRep) are the wizard's own
      // sponsor-selection data, which apex-attribution.js's URL/cookie-based
      // referral detection can't see on its own — pass them through explicitly
      // so a wizard-selected sponsor always yields referral_key
      // "Sponsor-led Enrollment" with the sponsor's name as referral_value.
      try {
        if (typeof window.__APEX_WRITE_CART_METAFIELDS__ === "function") {
          var apexOverrides = { delivery_date: stepThreeDate };
          if (enrollmentType === "sponsor" && member_id) {
            apexOverrides.sponsor = member_id;
            apexOverrides.referral_key = "Sponsor-led Enrollment";
            apexOverrides.referral_value = member_name;
          }
          // Volumes are NOT written here. Computing them server-side required
          // waiting for /cart.js to reflect the multi-item /cart/add.js (a
          // capped ~4s retry loop) plus a product-metafield GraphQL lookup —
          // three round trips on the critical path between the last click and
          // /checkout, purely to recompute numbers the page already knows.
          //
          // Total RV/BV/WV are already on the cart: they were posted as cart
          // attributes with /cart/add.js above, summed from each product's own
          // data-rv-meta/data-bv-meta/data-wv-meta, and they apply the same
          // step-three exclusion as apex's COUNT_SUBSCRIPTION_VOLUME = false.
          // So this write is now text-only — sponsor, referral and delivery
          // date, which come from localStorage and need no cart read at all.
          //
          // What this gives up: the apex.cart_lines per-line JSON breakdown and
          // the apex.volume1/2/3 cross-check against it. Existing values are
          // left untouched rather than zeroed (see skip_volumes in
          // apex-attribution.js).
          apexOverrides.skip_volumes = true;
          await window.__APEX_WRITE_CART_METAFIELDS__(apexOverrides);
        }
      } catch (e) {
        console.error("Apex metafield write before checkout failed — order metafields (sponsor/referral/delivery_date) may be missing:", e);
      }

      // Everything this redirect depends on (cart clear, cart add — which
      // carries the Total RV/BV/WV attributes — and the apex text write) is
      // already awaited above, so the old setTimeout(..., 1000) here was a fixed
      // 1s of dead wait on top of an already-slow submit. Run it immediately; the
      // IIFE keeps the early-return shape and the sponsorData shadowing exactly
      // as they were.
      (() => {
         let sponsorData = null;
         try {
           sponsorData = JSON.parse(localStorage.getItem("sponsorData"));
         } catch (e) {
           console.warn("sponsorData could not be parsed — skipping checkout prefill", e);
         }

    // Only prefill from a record this build wrote. A record left over from an
    // older build carries a name and address that belong to whoever last used
    // this browser, and prefilling it puts them on someone else's order.
    if (!sponsorData || sponsorData.v !== SPONSOR_DATA_VERSION) {
      if (sponsorData) {
        console.log("Ignoring sponsorData from an older shape — no checkout prefill");
      } else {
        console.log("No sponsor data found");
      }
      window.location.href = "/checkout";
      return;
    }

    // Send only the fields that actually hold a value. The form currently
    // collects country alone, so blanking out the rest of the address on the
    // checkout URL just overwrites whatever Shopify had for a logged-in
    // customer with empty strings.
    const addressFields = {
      first_name: sponsorData.firstName,
      last_name: sponsorData.lastName,
      address1: sponsorData.address,
      address2: sponsorData.address2,
      city: sponsorData.city,
      province: sponsorData.province,
      country: sponsorData.country,
      zip: sponsorData.zip,
    };

    const params = Object.keys(addressFields)
      .filter((key) => addressFields[key])
      .map(
        (key) =>
          "checkout[shipping_address][" + key + "]=" +
          encodeURIComponent(addressFields[key])
      );

    window.location.href = params.length
      ? "/checkout?" + params.join("&")
      : "/checkout";
      })();
    })
    .catch((error) => {
      console.error("Add to cart failed:", error);
      releaseEnrollmentSubmitLock();
    });
  };

  // Release the lock if the handler throws before reaching the fetch chain.
  button.addEventListener("click", function (event) {
    Promise.resolve(onEnrollmentCheckoutClick.call(this, event)).catch(function (error) {
      console.error("Enrollment submit failed unexpectedly:", error);
      releaseEnrollmentSubmitLock();
    });
  });
});



    document.querySelector(".skip-button").addEventListener("click", function () {
        var activeSection = document.querySelector(".membership.active");
        var index = activeSection ? parseInt(activeSection.getAttribute("data-index")) : null;

        if (activeSection && index !== null) {
            var skippedLi = document.querySelector(`.membership-cart ul li:nth-child(${index})`);
            var skippedNextLi = document.querySelector(`.membership-cart ul li:nth-child(${index + 1})`);

            var nextactiveArea = activeSection.nextElementSibling.getAttribute("data-index");

            if (skippedNextLi) {
                skippedNextLi.classList.add("active");
            }

            if (skippedLi) {
                if (!skippedLi.classList.contains("checked")) {
                    skippedLi.classList.add("skip");
                }
                skippedLi.classList.remove("checked");
                activeSection.classList.add("skipThis");
            }

            var nextSection = document.querySelector(`.membership[data-index="${index + 1}"]`);
            if (nextSection) {
                activeSection.classList.remove("active");
                nextSection.classList.add("active");
            }

            // STEP-2 visibility logic
            if (index === 2) {
                const hasItemsStep2 =
                    document.querySelectorAll('.order-section.step-two li').length > 0;

                const step2Section = document.querySelector(".order-section.step-two");

                if (hasItemsStep2) {
                    step2Section.classList.remove("hide");
                } else {
                    step2Section.classList.add("hide");
                }
            }

              // STEP-3 visibility logic
              if (index === 3) {
                  const hasItemsStep3 =
                      document.querySelectorAll('.order-section.step-three li').length > 0;

                  const step3Section = document.querySelector(".order-section.step-three");

                  if (hasItemsStep3) {
                      step3Section.classList.remove("hide");
                  } else {
                      step3Section.classList.add("hide");
                  }
              }

            if (index >= 3) {
                $(".CILI-member").removeClass("subdisable");
                $(".subtotal-calculation").removeClass("subdisable");
                $(".total-calculation ").removeClass("subdisable");
                $("input#consultantInput1").removeClass("disabled");
                navigation.classList.remove("active");
            } else {
                navigation.classList.add("active");
            }
        }
        updateStepCheckedClass();
        updateSkipButton();
        updateSkipButtonState();
    });

    document.querySelector(".proceed").addEventListener("click", function () {
        var activeSection = document.querySelector(".membership.active");
        var index = activeSection
            ? parseInt(activeSection.getAttribute("data-index"))
            : null;

        if (activeSection && index !== null) {
            var checkedLi = document.querySelector(
                `.membership-cart ul li:nth-child(${index})`
            );
            var checkedNextLi = document.querySelector(
                `.membership-cart ul li:nth-child(${index + 1})`
            );
            // this.classList.add("disabled");

            var proceedBtn = document.querySelector(".proceed");
            var nextactiveArea = activeSection.nextElementSibling;
            var active_sectionQty = 0;
            var proItems = nextactiveArea.querySelectorAll(".product-item");
            proItems.forEach(function (item) {
                var qtyInput = item.querySelector(".quantity__input");
                var itemqty = qtyInput ? parseInt(qtyInput.value) || 0 : 0;
                active_sectionQty += itemqty;
            });

            if (checkedNextLi) {
                checkedNextLi.classList.add("active");
                checkedLi.classList.remove("skip");

            }
            if (checkedLi) {
                checkedLi.classList.remove("skip");
                checkedLi.classList.add("checked");
                activeSection.classList.add("proceedThis");
            }
            var nextSection = document.querySelector(
                `.membership[data-index="${index + 1}"]`
            );
            if (nextSection) {
                activeSection.classList.remove("active");
                nextSection.classList.add("active");
            }
            // STEP-2 visibility logic
            if (index === 2) {
                const hasItemsStep2 =
                    document.querySelectorAll('.order-section.step-two li').length > 0;

                const step2Section = document.querySelector(".order-section.step-two");

                if (hasItemsStep2) {
                    step2Section.classList.remove("hide");
                } else {
                    step2Section.classList.add("hide");
                }
            }

              // STEP-3 visibility logic
              if (index === 3) {
                  const hasItemsStep3 =
                      document.querySelectorAll('.order-section.step-three li').length > 0;

                  const step3Section = document.querySelector(".order-section.step-three");

                  if (hasItemsStep3) {
                      step3Section.classList.remove("hide");
                  } else {
                      step3Section.classList.add("hide");
                  }
              }

            if (index >= 3) {
                $(".CILI-member").removeClass("subdisable");
                $(".subtotal-calculation").removeClass("subdisable");
                $(".total-calculation ").removeClass("subdisable");
                $("input#consultantInput1").removeClass("disabled");
                navigation.classList.remove("active");
            } else {
                navigation.classList.add("active");
            }
        }
        updateStepCheckedClass();
        updateSkipButton();
        updateSkipButtonState();
    });

    document.querySelector(".prev-button").addEventListener("click", function () {
        const activeSection = document.querySelector(".membership.active");
        const index = activeSection
            ? parseInt(activeSection.getAttribute("data-index"))
            : null;

        if (activeSection && index !== null && index > 1) {
            const prevSection = document.querySelector(
                `.membership[data-index="${index - 1}"]`
            );
            const currentLi = document.querySelector(
                `.membership-cart ul li:nth-child(${index})`
            );
            const prevLi = document.querySelector(
                `.membership-cart ul li:nth-child(${index - 1})`
            );

            // Move to previous section
            activeSection.classList.remove("active");
            prevSection.classList.add("active");
            prevSection.classList.remove("skip");

            // Update step indicator
            if (currentLi) currentLi.classList.remove("active");
            if (prevLi) prevLi.classList.add("active");

            // Show/hide sections if needed
            if (index === 3) {
                document.querySelector(".order-section.step-two").classList.add("hide");
            }
            if (index === 4) {
                document
                    .querySelector(".order-section.step-three")
                    .classList.add("hide");
            }

            if (index - 1 < 4) {
                $(".CILI-member").addClass("subdisable");
                $(".subtotal-calculation").addClass("subdisable");
                $(".total-calculation").addClass("subdisable");
                // $("input#consultantInput1").addClass("disabled");
            }

            // Toggle navigation
            if (index - 1 < 3) {
                navigation.classList.add("active");
            } else {
                navigation.classList.remove("active");
            }
        }
        updateStepCheckedClass();
        updateSkipButton();
        updateSkipButtonState();
    });




    document.querySelectorAll(".tag-filter-wrapper").forEach(function (wrapper) {
        wrapper.querySelectorAll(".tag-item").forEach((tagItem) => {
            tagItem.addEventListener("click", function () {
                var selectedTag = this.dataset.tag;
                wrapper
                    .querySelectorAll(".tag-item")
                    .forEach((item) => item.classList.remove("active"));
                this.classList.add("active");
                var section = wrapper.closest(".membership");
                var coll_products = section.querySelector(".collsecton-data");
                coll_products.querySelectorAll(".product-item").forEach((product) => {
                    var productTags = product.dataset.tags
                        ? product.dataset.tags.split(",")
                        : [];
                    if (selectedTag === "all" || productTags.includes(selectedTag)) {
                        product.style.display = "block";
                    } else {
                        product.style.display = "none";
                    }
                });
            });
        });
    });
    if (window.location.pathname === "/pages/enrollment") {
        fetch("/cart/clear.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (response.ok) {
                    console.log("Cart cleared successfully.");
                    // Optionally reload the page or notify the user
                    // location.reload();
                } else {
                    console.error("Failed to clear cart.");
                }
            })
            .catch((error) => console.error("Error clearing cart:", error));
    }
 document.addEventListener("input", saveStepData);
    document.addEventListener("click", saveStepData);
    restoreStepData();
});
function renderSidebarProduct(id, qty, step) {  
    const item = document.querySelector(`.product-item[data-id="${id}"], .product-item[data-product-id="${id}"]`);
    if (!item) return;

    const title = item.getAttribute("data-title");
    const image = item.getAttribute("data-image");

    // Correct list based on step
    let listSelector =
        step === "step-one" ? "#step1Products" :
        step === "step-two" ? "#step3Products" :
        "#step2Products";

    const list = document.querySelector(listSelector);
    if (!list) return;

        const old = list.querySelector(`.product-slide[data-id="${id}"]`);
        if (old) old.remove();

    // Create card
    const li = document.createElement("div");
    li.classList.add("product-slide");
    li.setAttribute("data-id", id);
    li.setAttribute("data-step", step);

    li.innerHTML = `
        <div class="step-product-item">
            <img src="${image}" alt="${title}">
            <h3>${qty}x ${title}</h3>
        </div>
    `;

    list.appendChild(li);
}

$(document).on("click", ".gift-close-btn, .popup-overlay", function () {
    const $popup = $(this).closest(".gift-popup");
    if ($popup.hasClass("fullfilqty")) {
        $('li.subdisable[data-index="2"] .step-list').trigger('click');
    }
    $popup.fadeOut(200, function () {
        $(this).removeClass("active");
        $("body").removeClass("gift-popup-open");
    });
});

$(document).on("click", ".gift-btn-proceed", function () {
    const $popup = $(this).closest(".gift-popup");
    const btn = document.querySelector(".gift-btn-proceed");
btn.classList.add("hidden-proceed");
    if ($popup.hasClass("fullfilqty")) {
  $('li.subdisable[data-index="2"] .step-list').trigger('click');

  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}

    $(".gift-popup").fadeOut();
});


document.addEventListener("DOMContentLoaded", function () {
    const freeContainers = document.querySelectorAll(".free-autoship-product");

    if (freeContainers.length > 0) {
        freeContainers.forEach((freeContainer) => {
            let giftContainer = freeContainer.querySelector("ul");

            // If ul not found, create it
            if (!giftContainer) {
                giftContainer = document.createElement("ul");
                giftContainer.classList.add("free", "order-list");
                freeContainer.appendChild(giftContainer);
                console.log("✅ Created new giftContainer <ul> for", freeContainer);
            } else {
                console.log("✅ Found existing giftContainer <ul> for", freeContainer);
            }
        });
    } else {
        console.error("⚠ .free-autoship-product not found");
    }
});


function updateGiftUI(step, giftProductDataArray) {
    console.log("productItem step:", step);

let $carouselList, staticListContainer;

if (step === "two") {
    $carouselList = $("#step2Products");
    staticListContainer = document.querySelector(".order-section.step-three");
} else if (step === "one") {
    $carouselList = $("#step1Products");
    staticListContainer = document.querySelector(".order-section.step-one");
} else {
    $carouselList = $("#step3Products");
    staticListContainer = document.querySelector(".order-section.step-two");
}

console.log($carouselList, staticListContainer);

  if (!$carouselList.length) {
    console.warn("❌ #step2Products not found");
    return;
  }

  if (!staticListContainer) {
    console.warn("❌ .order-section.step-two not found");
    return;
  }

giftProductDataArray.forEach((gift) => {
    const giftID = String(gift.id);
    const quantity = gift.quantity || 1;

    // Same parent resolution saveStepData uses, so these rows and the ones
    // restoreStepData renders from the saved gifts share one key.
    const mainProductID =
        gift.mainProductID ||
        resolveGiftParentProductId(
            document.querySelector(`.gift-item[data-variant-id="${giftID}"]`),
            readGiftPopupStorage(),
            giftID
        );

    const giftPopupElement = document.querySelector(
        `.gift-popup[data-id="${mainProductID}"]`
    );

    const dataStepGift = giftPopupElement?.getAttribute("data-step") || "two";

    const title = gift.title;
    const image = gift.image;

    $carouselList
        .find(`.product-slide[data-id="${giftID}"][data-main-id="${mainProductID}"]`)
        .remove();

    const divCard = document.createElement("div");
    divCard.className = "product-slide";
    divCard.setAttribute("data-id", giftID);
    divCard.setAttribute("data-main-id", mainProductID);
    if (step === "two") {
    divCard.setAttribute("data-step", "two");
    }else{
    divCard.setAttribute("data-step", dataStepGift);
    }
    divCard.setAttribute("type", "gift");

    const innerDiv = document.createElement("div");
    innerDiv.className = "step-product-item";

    innerDiv.innerHTML = `
        <span class="remove-icon" title="Remove gift">&times;</span>
        ${image ? `<img src="${image}" alt="${title}">` : ""}
        <h3>${quantity}x ${title}</h3>
    `;

    divCard.appendChild(innerDiv);
    $carouselList.append(divCard);

    /* =====================================================
       🟢 STATIC SUMMARY LIST (FINISH STEP)
    ===================================================== */

    const staticGiftList = finishStepGiftList(staticListContainer, mainProductID);

    // ❌ remove same gift if exists
    staticGiftList
        .querySelector(`li[data-id="${giftID}"][data-main-id="${mainProductID}"]`)
        ?.remove();

    const staticLi = document.createElement("li");
    staticLi.setAttribute("data-id", giftID);
    if (step === "two") {
    staticLi.setAttribute("data-step", "two");
    }else{
    staticLi.setAttribute("data-step", dataStepGift);
    }
    staticLi.setAttribute("data-main-id", mainProductID);
    staticLi.setAttribute("type", "gift");

    staticLi.innerHTML = `
        <span class="remove-icon" title="Remove gift">&times;</span>
        <div class="order-list-info">
            ${image ? `<img src="${image}" class="membership-image">` : ""}
            <span class="order-list-item-qty">${quantity}x</span>
            <p>${title}</p>
        </div>
    `;

    staticGiftList.appendChild(staticLi);
});


  console.log("✅ Gift UI updated: using <div> in carousel");
}





function updateGiftSelectionState($productItem) {
    var step = $productItem.data("step");
    var giftProceedBtn = $productItem?.find(".gift-btn-proceed");
    var hasSelectedGift =$productItem.find(".gift-item .quantity-input").filter((_, el) => parseInt($(el).val()) > 0).length > 0;

    $productItem.toggleClass("add-free-product", hasSelectedGift);
    giftProceedBtn.toggleClass("disabled", !hasSelectedGift);

    let giftProductDataArray = [];

    const mainProductID = $productItem.find(".gift-item").first().data("main-id");
    console.log(" Detected mainProductID:", mainProductID);

    $productItem.find(".gift-item").each(function () {
        let $item = $(this);
        let qty = parseInt($item.find(".quantity-input").val()) || 0;
        if (qty > 0) {
            giftProductDataArray.push({
                id: $item.attr("data-variant-id"),
                title: $item.attr("data-title"),
                image: $item.attr("data-image"),
                price: $item.attr("data-price"),
                currencySymbol: $item.attr("data-currency-symbol"),
                quantity: qty,
                mainProductID: resolveGiftParentProductId(
                    this,
                    readGiftPopupStorage(),
                    $item.attr("data-variant-id")
                ),
            });
        }
    });

    console.log("giftProductDataArray", giftProductDataArray);
updateGiftUI(step, giftProductDataArray);
}
// ---------------------- PLUS BUTTON ----------------------
$(document).on("click", '.gift-item .quantity-btn[name="plus"]', function () {
    var $input = $(this).siblings(".quantity-input");
    var currentQty = parseInt($input.val()) || 0;

    var $productItem = $(this).closest(".gift-popup");
    var step = $productItem.data("step");

    let mainQty;

    // ---------------------- STEP = TWO ----------------------
    if (step === "two") {

        let mainQty = 0;
        $('.product-item[gift-true][data-step="two"] .quantity__input').each(function () {
            mainQty += parseInt(this.value) || 0;
        });

        let totalGiftsSelected = 0;
        $('.gift-popup[data-step="two"] .gift-item .quantity-input').each(function () {
            totalGiftsSelected += parseInt(this.value) || 0;
        });

        console.log("Main:", mainQty, "Gifts:", totalGiftsSelected);
        let maxGifts = stepFreeSprayAllowance("two");

        if (totalGiftsSelected >= maxGifts) {
            alert(`You can select up to ${maxGifts} gift(s)`);
            return;
        }
        $('.order-section[data-step="two"] .order-inner-2.free-autoship-product').remove();
    }
    // ---------------------- STEP = ONE ----------------------
   else if (step === "one") {

  const maxGifts = stepFreeSprayAllowance("one");
const btn = document.querySelector(".gift-btn-proceed");
  let totalGiftsSelected = 1;
  $('.gift-popup[data-step="one"] .gift-item .quantity-input').each(function () {
    totalGiftsSelected += parseInt(this.value) || 0;
  });
  const remainingGifts = maxGifts - totalGiftsSelected;
  console.log({
    totalGiftsSelected,
    maxGifts,
    remainingGifts
  });

  /* ---------- PROCEED BUTTON ---------- */
  if (totalGiftsSelected === maxGifts) {
  btn.classList.remove("hidden-proceed");
} else {
  btn.classList.add("hidden-proceed");
}

  /* ---------- HARD LIMIT ENFORCEMENT ---------- */
  if (remainingGifts <= 0) {
    btn.classList.remove("hidden-proceed");
    $('.gift-popup[data-step="one"]')
      .addClass('fullfilqty')
      .find('.qty-plus, .quantity-plus')
      .prop('disabled', true)
      .addClass('disabled');
  } else {
    $('.gift-popup[data-step="one"]')
      .removeClass('fullfilqty')
      .find('.qty-plus, .quantity-plus')
      .prop('disabled', false)
      .removeClass('disabled');
  }

  /* ---------- SAFETY CHECK (LAST LINE OF DEFENSE) ---------- */
  if (totalGiftsSelected > maxGifts) {
    alert(`You can select only ${maxGifts} gift(s).`);
    return;
  }

  $('.order-section[data-step="one"] .order-inner-2.free-autoship-product').remove();
}




    // ---------------------- CURRENT PRODUCT TOTAL GIFTS ----------------------
    let currentGiftTotal = 0;
    $productItem.find(".gift-item .quantity-input").each(function () {
        currentGiftTotal += parseInt($(this).val()) || 0;
    });

    if (currentGiftTotal >= mainQty) {
        alert(`You can select up to ${mainQty} gift(s)`);
        return;
    }

    // INCREMENT
    $input.val(currentQty + 1);

    // The plus handler registered earlier calls saveGiftData before this
    // increment, so a first spray click stored qty 0 and never wrote mainId.
    // Save again with the quantity this click just set.
    // Subscription sprays (step "two") stay on that earlier handler.
    if (step === "one") {
      var $giftItem = $(this).closest(".gift-item");
      saveGiftData($productItem, String($giftItem.data("variant-id")), currentQty + 1);
    }

    updateGiftSelectionState($productItem);
});

// ---------------------- MINUS BUTTON ----------------------
$(document).on("click", '.gift-item .quantity-btn[name="minus"]', function () {

  const maxGifts = stepFreeSprayAllowance("one");

  const btn = document.querySelector(".gift-btn-proceed");

  let totalGiftsSelected = 0;
  $('.gift-popup[data-step="one"] .gift-item .quantity-input').each(function () {
    totalGiftsSelected += parseInt(this.value) || 0;
  });

  console.log("harsh:", maxGifts, "Gifts:", totalGiftsSelected);
 if (totalGiftsSelected === maxGifts) {
  btn.classList.remove("hidden-proceed");
} else {
  btn.classList.add("hidden-proceed");
}



    var $input = $(this).siblings(".quantity-input");
    var newValue = Math.max(parseInt($input.val()) - 1, 0);
    $input.val(newValue);

    // Same ordering as plus: the earlier minus handler saves the pre-decrement
    // quantity. Rewrite step-one spray storage with the quantity now shown.
    var $popup = $(this).closest(".gift-popup");
    if ($popup.data("step") === "one") {
      saveGiftData($popup, String($(this).closest(".gift-item").data("variant-id")), newValue);
    }

    var $productItem = $(this).closest(".product-item");
    updateGiftSelectionState($productItem);
        var giftVariantId = $(this).closest(".gift-item").attr("data-variant-id");
        document.querySelector(
            `.step-product-list .product-slide[type="gift"][data-id="${giftVariantId}"]`
        )?.remove();
});


// ---------------------- MAIN PRODUCT INPUT CHANGE ----------------------
$(document).on("change input", ".quantity__input", function () {

    var $productItem = $(this).closest(".product-item");
    var step = $productItem.data("step");
    let mainQty;

    // ---------------------- STEP = TWO ----------------------
    if (step === "two") {

        let totalGiftsSelected = 0;

        $('.product-item[gift-true][data-step="two"]').each(function () {
            $(this).find('.gift-item .quantity-input').each(function () {
                totalGiftsSelected += parseInt($(this).val()) || 0;
            });
        });

        mainQty = parseInt($productItem.find(".quantity__input").val()) || 0;

        const subscriptionPopup = document.querySelector('.gift-popup[data-step="two"]');
        const subscriptionLimit = subscriptionPopup
            ? popupOpenLimit(subscriptionPopup)
            : SUBSCRIPTION_SPRAY_CAP;
        if (totalGiftsSelected > subscriptionLimit) {

            let allowedLeft = subscriptionLimit;

            $('.product-item[gift-true][data-step="two"]').each(function () {
                $(this).find('.gift-item .quantity-input').each(function () {

                    let $giftInput = $(this);
                    let giftQty = parseInt($giftInput.val()) || 0;

                    if (giftQty > 0) {

                        if (giftQty <= allowedLeft) {
                            allowedLeft -= giftQty;
                        } else {
                            $giftInput.val(allowedLeft);
                            allowedLeft = 0;
                        }
                    }
                });
            });
        }
    }

    // ---------------------- STEP = ONE ----------------------
    else if (step === "one") {
        let totalGiftsSelected = 0;

        $('.product-item[gift-true][data-step="one"]').each(function () {
            $(this).find('.gift-item .quantity-input').each(function () {
                totalGiftsSelected += parseInt($(this).val()) || 0;
            });
        });

        mainQty = parseInt($productItem.find(".quantity__input").val()) || 0;

        // Auto-fix if total gifts exceed free sprays allowed for current qty
        const maxGifts = stepFreeSprayAllowance("one");
        if (totalGiftsSelected > maxGifts) {

            let allowedLeft = maxGifts;

            $('.product-item[gift-true][data-step="one"]').each(function () {
                $(this).find('.gift-item .quantity-input').each(function () {

                    let $giftInput = $(this);
                    let giftQty = parseInt($giftInput.val()) || 0;

                    if (giftQty > 0) {

                        if (giftQty <= allowedLeft) {
                            allowedLeft -= giftQty;
                        } else {
                            $giftInput.val(allowedLeft);
                            allowedLeft = 0;
                        }
                    }
                });
            });
        }
    }

    // ---------------------- DEFAULT ----------------------
    else {
        mainQty = parseInt($productItem.find(".quantity__input").val()) || 0;
    }

    updateGiftSelectionState($productItem);
});


$(document).on("keypress", ".helper-section input", function (event) {
    var apiData = [
        { id: 1, name: "John Doe" },
        { id: 2, name: "Jane Smith" },
    ];

    var query = $(this).val().trim().toLowerCase();

    $(this).addClass("ssss");

    if (query.length < 1) {
        console.log([]);
        return;
    }

    var filteredResults = apiData.filter((item) =>
        item.name.toLowerCase().includes(query)
    );

    if (filteredResults.length > 0) {
        $(".CILI-member").removeClass("subdisable");
        $(".subtotal-calculation").removeClass("subdisable");
    } else {
        $(".CILI-member").addClass("subdisable");
        $(".subtotal-calculation").addClass("subdisable");
        console.log("notmatches");
    }
});

$(document).on("click",
".membership.finish-step .step-two .change-link",
    function (e) {
        e.preventDefault();
        $('.membership[data-index="4"]').removeClass("active");
        $('.membership[data-index="2"]').addClass("active");
        $(".membership-cart li:nth-child(2)").removeClass("checked");
        $(".membership-cart li:nth-child(3)").removeClass("active checked");
        $(".membership-cart li:nth-child(4)").removeClass("active");
        $(".membership-navigation").addClass("active");
        var active_sectionQty = 0;
        $('.membership[data-index="2"] .product-item').each(function () {
            var qty = parseInt($(this).find(".quantity__input").val());
            active_sectionQty = active_sectionQty + qty;
        });
        if (active_sectionQty == 0) {
            $(".proceed").addClass("disabled");
        } else {
            $(".proceed").removeClass("disabled");
        }
    }
);

$(document).on(
    "click",
    ".membership.finish-step .step-three .change-link",
    function (e) {
        e.preventDefault();
        $('.membership[data-index="4"]').removeClass("active");
        $('.membership[data-index="3"]').addClass("active");
        $(".membership-cart li:nth-child(3)").removeClass("checked");
        $(".membership-cart li:nth-child(4)").removeClass("active");
        $(".membership-navigation").addClass("active");
        var active_sectionQty = 0;
        $('.membership[data-index="3"] .product-item').each(function () {
            var qty = parseInt($(this).find(".quantity__input").val());
            active_sectionQty = active_sectionQty + qty;
        });
        if (active_sectionQty == 0) {
            $(".proceed").addClass("disabled");
        } else {
            $(".proceed").removeClass("disabled");
        }
    }
);

$(document).on("click", ".membership.finish-step .step-one .change-link", function (e) {
    e.preventDefault();
    $('.membership[data-index="4"]').removeClass("active");
    $('.membership[data-index="1"]').addClass("active");
    $(".membership-cart .subdisable").removeClass("active checked");
    $(".membership-cart li:nth-child(1)").removeClass("checked");
    $(".membership-navigation").removeClass("active");
    var active_sectionQty = 0;
    $('.membership[data-index="1"] .product-item').each(function () {
        var qty = parseInt($(this).find(".quantity__input").val());
        active_sectionQty = active_sectionQty + qty;
    });
    if (active_sectionQty == 0) {
        $(".proceed").addClass("disabled");
    } else {
        $(".proceed").removeClass("disabled");
    }
});

document.addEventListener("DOMContentLoaded", function () {

    const memberInput = document.getElementById("consultantInput1");
    const memberInputAlt = document.getElementById("consultantInput");
    const memberInput1 = document.querySelector(".helper-section1 input");

    const resultsList = document.querySelector(".members_data ul");
    const resultArea = document.querySelector(".members_data");

    const resultsListAlt = document.querySelector(".members_data_alt ul");
    const resultAreaAlt = document.querySelector(".members_data_alt");

    const resultsList1 = document.querySelector(".members_data1 ul");
    const resultArea1 = document.querySelector(".members_data1");

    // Form Inputs and Buttons
    const memberForm = document.querySelector(".checkout-buttons form input");
    const memberFormRight = document.querySelector(
        ".checkout-buttons-procced form input"
    );
    const proceedBtn = document.querySelector(
        ".checkout-buttons-procced button.checkout-btn"
    );

    // ✅ Set selected member everywhere
    function setMemberName(fullName, repObj) {
        if (memberForm) memberForm.value = fullName;
        if (memberFormRight) memberFormRight.value = fullName;
        if (memberInput) memberInput.value = fullName;
        if (memberInputAlt) memberInputAlt.value = fullName;
        if (memberInput1) memberInput1.value = fullName;

        const selectedRepText = document.getElementById("selectedRepText");
        if (selectedRepText) selectedRepText.textContent = fullName;

        if (repObj) {
            localStorage.setItem("selectedRep", JSON.stringify(repObj));
            // Header photo otherwise only refreshes on reload (global.js).
            const repId = repObj["rep_#"] || repObj.repId || repObj.id || null;
            if (repId) window.cbdUpdateRepPhoto?.(repId);
        }

        document
            .querySelectorAll(".product-right-box .rightlaststep")
            ?.forEach((el) => el.classList.remove("subdisable"));
        document
            .querySelector(".membership-navigation .proceed")
            ?.classList.remove("disabled");
        document
            .querySelector(".finish-step .checkout-buttons button")
            ?.classList.remove("disabled");
        proceedBtn?.classList.remove("disabled");

        console.log("CILIMember set to:", fullName);
    }

    // ✅ Build a result <li>
    function buildResultItem(item, inputContext = "default") {
        const fullName = `${item.first_name || ""} ${item.last_name || ""}`.trim();
        const addressParts = [item.city, item.state, item.country].filter(Boolean);
        const fullAddress = addressParts.join(", ");

        const li = document.createElement("li");
        li.classList.add("member-item");
        li.innerHTML = `
      <span class="membername">${fullName}</span>
      <span class="member_address">${fullAddress}</span>
    `;

        li.addEventListener("click", () => {
            setMemberName(fullName, item);

            syncSelectedSponsor(item, fullName);

            // Hide the appropriate result area
            if (inputContext === "1" && resultArea1)
                resultArea1.style.display = "none";
            else if (inputContext === "alt" && resultAreaAlt)
                resultAreaAlt.style.display = "none";
            else if (resultArea) resultArea.style.display = "none";
        });

        return li;
    }

    // ✅ Fetch + Render
    function fetchAndRenderResults(inputEl, resultsUl, resultsDiv, context) {
        const searchTerm = inputEl?.value?.trim();
        console.log(`Fetching for context [${context}] with term:`, searchTerm);

        if (!inputEl || !resultsUl || !resultsDiv) return;

        if (!searchTerm) {
            resultsDiv.style.display = "none";
            resultsUl.innerHTML = "";
            proceedBtn?.classList.add("disabled");
            document
                .querySelector(".finish-step .checkout-buttons button")
                ?.classList.add("disabled");
            document
                .querySelectorAll(".product-right-box .rightlaststep")
                ?.forEach((el) => el.classList.add("subdisable"));
            return;
        }

        const apiUrl = `https://cbd.kwik.dev/ords/cbd/pub/rep/search/${encodeURIComponent(
            searchTerm
        )}`;
        console.log("API URL:", apiUrl);

        fetch(apiUrl)
            .then((response) => response.json())
            .then((data) => {
                if (!resultsUl || !resultsDiv) return;
                resultsUl.innerHTML = "";
                resultsDiv.style.display = "block";

                if (Array.isArray(data.items) && data.items.length > 0) {
                    data.items.forEach((item) => {
                        const li = buildResultItem(item, context);
                        resultsUl.appendChild(li);
                    });
                } else {
                    resultsUl.innerHTML = "<li class='noresult'>No results found.</li>";
                }
            })
            .catch((error) => {
                console.error("Error fetching API:", error);
                if (resultsUl && resultsDiv) {
                    resultsUl.innerHTML =
                        "<li class='errorloading'>Error loading data.</li>";
                    resultsDiv.style.display = "block";
                }
            });
    }


    function checkStoredRepMatch() {
        const stored = localStorage.getItem("selectedRep");
        if (!stored) return;

        try {
            const rep = JSON.parse(stored);
            const fullName = `${rep.first_name} ${rep.last_name}`.trim();
            setMemberName(fullName, rep);
        } catch (e) {
            console.error("Error parsing selectedRep from localStorage:", e);
        }
    }

    function checkSubdisableStatus() {
        const div = document.querySelector(".checkout-proceed.rightlaststep");
        const warning = document.getElementById("warning");
        if (div?.classList.contains("subdisable")) {
            warning?.style?.setProperty("display", "block");
        } else {
            warning?.style?.setProperty("display", "none");
        }
    }

    memberInput?.addEventListener("input", () => {
        fetchAndRenderResults(memberInput, resultsList, resultArea, "1");
    });

    // Self-led keeps the sponsor locked (customNew.css .helper-section1 input
    // blocks clicks, readOnly blocks Tab-focus + typing); sponsor-led and
    // no-type enrollment may pick/change it.
    if (memberInput1 && currentEnrollmentType() === "self") {
        memberInput1.readOnly = true;
        memberInput1.tabIndex = -1;
    } else if (memberInput1) {
        memberInput1.classList.add("sponsor-editable");
    }

    memberInput1?.addEventListener("input", () => {
        fetchAndRenderResults(memberInput1, resultsList1, resultArea1, "1");
    });

    memberInputAlt?.addEventListener("input", () => {
        fetchAndRenderResults(memberInputAlt, resultsListAlt, resultAreaAlt, "alt");
    });

    checkStoredRepMatch();
    setInterval(checkSubdisableStatus, 1000);
});


document.addEventListener("DOMContentLoaded", function () {

    function handleProductClick(buttonSelector, productSelector, listSelector) {
        console.log(`📌 Binding click handlers for ${buttonSelector} → ${listSelector}`);

        const buttons = document.querySelectorAll(buttonSelector);
        if (buttons.length === 0) {
            console.warn(`⚠️ No buttons found for selector: ${buttonSelector}`);
        }

        buttons.forEach(function (button, idx) {
            button.addEventListener("click", function () {
                console.log(`🟢 Button clicked [${idx}] for ${listSelector}`);
                
    const activeStep = document.querySelector(".membership.active");
    const stepIndex = activeStep.dataset.index;

    const skipBtn = document.querySelector(".skip-button");

    let hiddenSteps = (skipBtn.dataset.hiddenSteps || "")
        .split(",")
        .filter(Boolean);

    if (!hiddenSteps.includes(stepIndex)) {
        hiddenSteps.push(stepIndex);
    }

    skipBtn.dataset.hiddenSteps = hiddenSteps.join(",");

    updateSkipButton();
    updateSkipButtonState();

                const productItem = button.closest(productSelector);
                if (!productItem) {
                    console.warn(`❌ Could not find productItem using selector: ${productSelector}`);
                    return;
                }

                const image = productItem.getAttribute("data-image");
                const title = productItem.getAttribute("data-title");
                const productID = productItem.getAttribute("data-product-id");
                const dataStep = productItem.getAttribute("data-step")
                const isGift = productItem.hasAttribute("gift-true");

                console.log("📦 Product data extracted:", { image, title, productID });

                if (!image || !title) {
                    console.warn("⚠️ Missing product image or title. Skipping.");
                    return;
                }

                const productList = document.querySelector(listSelector);
                if (!productList) {
                    console.error(`❌ productList (${listSelector}) not found in DOM`);
                    return;
                }

                console.log(`📥 Appending to list: ${listSelector}`);

                // ✅ Check if already exists
                let existingItem = null;
                if (productID) {
                    existingItem = [...productList.children].find(child =>
                        child.getAttribute("data-id") === productID
                    );
                }
                if (!existingItem && title) {
                    existingItem = [...productList.children].find(child =>
                        child.getAttribute("data-title") === title
                    );
                }

                if (existingItem) {
                    console.log(`♻️ Updating quantity for: ${title}`);

                    const h3 = existingItem.querySelector("h3");
                    const match = h3.textContent.match(/^(\d+)x\s/);
                    let currentQty = match ? parseInt(match[1], 10) : 1;

                    currentQty += 1;
                    h3.textContent = `${currentQty}x ${title}`;
                    existingItem.setAttribute("data-qty", currentQty);
                    return;
                }

                const li = document.createElement("div");
                li.classList.add("product-slide");
                if (productID) li.setAttribute("data-id", productID);
                li.setAttribute("data-title", title);
                li.setAttribute("data-qty", 1);
                li.setAttribute("data-step", dataStep);
                li.setAttribute("type", "main");
                if (isGift) {
                li.setAttribute("gift", "true");
                }

                const div = document.createElement("div");
                div.classList.add("step-product-item");

                const removeIcon = document.createElement("span");
                    removeIcon.classList.add("remove-icon");
                    removeIcon.innerHTML = "&times;"; // × symbol
                    removeIcon.title = "Remove gift";
                 const mainIndex= document.querySelector(`${listSelector}`).closest(".step-first-subdisable")?.getAttribute("data-index")
                if( mainIndex != 1){
                    div.appendChild(removeIcon);
                }
                //div.appendChild(removeIcon);
                const img = document.createElement("img");
                img.src = image;
                img.alt = title;

                const h3 = document.createElement("h3");
                h3.textContent = `1x ${title}`;

                div.appendChild(img);
                div.appendChild(h3);
                li.appendChild(div);


                if (listSelector === "#step1Products") {
                    console.log("🧹 Clearing existing #step1Products items before adding new one");
                    // productList.innerHTML = "";
                }

                productList.appendChild(li);
                console.log(`✅ Product added to ${listSelector} list`);

            });
        });
    }

    function syncQuantityOnChange() {
      document.addEventListener("click", function (event) {
        const isPlus = event.target.closest(".quantity__button[name='plus']");
        const isMinus = event.target.closest(".quantity__button[name='minus']");
        if (!isPlus && !isMinus) return;

        const button = isPlus || isMinus;
        const input = button.closest(".quantity")?.querySelector(".quantity__input");
        if (!input) return;

        setTimeout(() => {
          const quantity = parseInt(input.value, 10);
          const productID = input.dataset.quantityVariantId;

          const productItem = button.closest("[data-step]");
          const dataStep = productItem?.getAttribute("data-step");

          if (!productID || isNaN(quantity) || !dataStep) {
            console.warn("⚠️ Missing data", { productID, quantity, dataStep });
            return;
          }

          console.log("🔄 Sync qty:", productID, dataStep, quantity);

          document
            .querySelectorAll(
              `.product-slide[data-id="${productID}"][data-step="${dataStep}"]`
            )
            .forEach(slide => {
              const h3 = slide.querySelector("h3");
              const title = slide.getAttribute("data-title") || "Product";
              if (h3) {
                h3.textContent = `${quantity}x ${title}`;
                slide.setAttribute("data-qty", quantity);
              }
            });

          const orderItem = document.querySelector(
            `.order-section[data-step="${dataStep}"] li[data-id="${productID}"]`
          );

          if (!orderItem) {
            console.warn("❌ Order item not found:", productID, dataStep);
            return;
          }

          const qtyEl = orderItem.querySelector(".order-list-item-qty");
          if (qtyEl) {
            qtyEl.textContent = `${quantity}x`;
            qtyEl.setAttribute("data-pty", quantity);
          }

        }, 100);
      });
    }

    handleProductClick(
        ".product-item.product-section-description .add-to-cart-step-0 button",
        ".product-item.product-section-description",
        "#step1Products"
    );

    handleProductClick(
        ".product-item.product-section-description .add-to-cart-step-1 button",
        ".product-item.product-section-description",
        "#step2Products"
    );

    handleProductClick(
        ".product-item.product-section-description .add-to-cart-step-2 button",
        ".product-item.product-section-description",
        "#step3Products"
    );

    syncQuantityOnChange();
});




function removeProductIfQuantityZero(productItem, productID, quantity, index) {
    const dataStep = productItem?.getAttribute("data-step");
    console.log(`🔍 Checking quantity for "${productID}" in step "${dataStep}": ${quantity}`);

    if (quantity <= 0) {
        console.warn("⚠ Quantity is zero or less, attempting removal...");
        // Agar index 0 hai to sirf step2Products ko remove karo
        if (!dataStep) {
            console.error("❌ Missing data-step on productItem. Cannot proceed.");
            return;
        }

        // Remove main product slide
        const matchingSlide = document.querySelector(`.product-slide[data-id="${productID}"][data-step="${dataStep}"]`);
        if (matchingSlide) {
            matchingSlide.remove();
            console.log(`🗑 Removed product "${productID}" from step "${dataStep}"`);
        } else {
            console.warn(`⚠️ No matching slide found for removal with ID "${productID}" and step "${dataStep}"`);
        }

        // Remove linked gifts for the same step
        document.querySelectorAll(`.product-slide[data-main-id="${productID}"]`).forEach(gift => {
            const giftStep = gift.getAttribute("data-step");
            if (giftStep === dataStep) {
                const itemId = gift.getAttribute("data-id");
                const giftElement = document.querySelector(`.free-autoship-product #gift-list-${itemId}`);
                if (giftElement) giftElement.remove();
                console.log(`🗑 Removing carousel gift linked to main ID: ${productID} and step: ${giftStep}`);
                gift.remove();
            } else {
                console.log(`⛔ Skipped removing gift for step ${giftStep}, does not match removed step ${dataStep}`);
            }
        });
        setTimeout(function(){
        updateGiftCOunt();
        },400);

    } else {
        console.log(`ℹ️ Quantity for "${productID}" is above zero — no removal needed.`);
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const productListIds = ["step1Products", "step2Products", "step3Products"];
    const scrollAmount = 270;

    productListIds.forEach(setupSliderWatcher);

    function setupSliderWatcher(id) {
        const productList = document.getElementById(id);

        if (!productList) {
            console.warn(`❌ #${id} not found`);
            return;
        }

        const observer = new MutationObserver(() => {
            updateSlider(productList);
        });

        observer.observe(productList, { childList: true });

        updateSlider(productList);
    }

    function updateSlider(productList) {
        // ✅ Change from <li> to .product-slide
        const items = productList.querySelectorAll(".product-slide");

        const wrapper = productList.closest(".dynamic-slider-wrapper");

        if (items.length <= 1) {
            // Remove wrapper if only one or no items
            if (wrapper) {
                const parent = wrapper.parentNode;
                parent.insertBefore(productList, wrapper);
                wrapper.remove();
            }
            return;
        }

        // Don't re-wrap if already wrapped
        if (wrapper) return;

        // Create wrapper and buttons
        const newWrapper = document.createElement("div");
        newWrapper.classList.add("dynamic-slider-wrapper");

        const prevBtn = document.createElement("button");
        prevBtn.textContent = "❮";
        prevBtn.classList.add("slider-nav-btn", "prev-slide");

        const nextBtn = document.createElement("button");
        nextBtn.textContent = "❯";
        nextBtn.classList.add("slider-nav-btn", "next-slide");

        // Insert new wrapper around the product list
        productList.parentNode.insertBefore(newWrapper, productList);
        newWrapper.appendChild(prevBtn);
        newWrapper.appendChild(productList);
        newWrapper.appendChild(nextBtn);

        // Scroll button logic
        nextBtn.addEventListener("click", () => {
            productList.scrollBy({ left: scrollAmount, behavior: "smooth" });
        });

        prevBtn.addEventListener("click", () => {
            productList.scrollBy({ left: -scrollAmount, behavior: "smooth" });
            
        });
    }
});


// ===============================
// ✅ UNIVERSAL REMOVE BUTTON FIX
// ===============================
    document.addEventListener("click", function (e) {
        const removeBtn = e.target.closest(".remove-icon");
          toggleOrderSection(1);
  toggleOrderSection(2);
  toggleOrderSection(3);
        if (!removeBtn) return;


        const slide = removeBtn.closest(".product-slide");
        if (!slide) return;

        const productId = slide.getAttribute("data-id");
        const step = slide.getAttribute("data-step");
if (step === "two") {
    return;
}
        console.log("🗑 Removing product:", productId, "from", step);

        // 1️⃣ Remove sidebar slide
        slide.remove();

        /* ================= STEP RESET LOGIC (ADDED) ================= */
        if (step === "one") {
              const btn = document.querySelector(".gift-btn-proceed");
              btn.classList.add("hidden-proceed");
            const step1Count = document.querySelectorAll("#step1Products .product-slide").length;

            if (step1Count === 0) {

                // Reset all steps
                document.querySelectorAll(".custom-step-list li").forEach(li => {
                    li.classList.remove("active", "click", "checked");
                    li.classList.add("skip");
                });

                // Activate Step 1 only
                const step1Li = document.querySelector('.custom-step-list li[data-index="1"]');
                if (step1Li) {
                    step1Li.classList.remove("skip");
                    step1Li.classList.add("active", "click");
                }

                // Reset left-side membership
                document
                    .querySelectorAll(".custom-product-left-content .membership")
                    .forEach(el => el.classList.remove("active"));

                const step1Membership = document.querySelector(
                    '.custom-product-left-content .membership[data-index="1"]'
                );
                if (step1Membership) step1Membership.classList.add("active");

                console.log("🔄 Step reset to Step 1 (no products left in step 1)");
            }
        }
        /* ================= END STEP RESET LOGIC ================= */

        // 2️⃣ Remove only the sprays linked to this product. Other parents'
        // sprays stay; a product without sprays (Additional) touches none.
        releaseParentSprays(productId);
        document
            .querySelectorAll(`.product-slide[type="gift"][data-main-id="${productId}"]`)
            .forEach(gift => gift.remove());

        const freeGiftItems = document.querySelectorAll(
            `.free.order-list[data-main-id="${productId}"]`
        );
        if (freeGiftItems.length) {
            freeGiftItems.forEach(li => li.remove());
        }
        document
            .querySelectorAll(`.free.order-list li[data-main-id="${productId}"]`)
            .forEach(el => el.remove());

        // 2.5️⃣ Reset gift quantities linked to this main product
        document.querySelectorAll(`.gift-item[data-main-id="${productId}"]`).forEach(gift => {

            const giftQtyInput =
                gift.querySelector(".quantity__input") ||
                gift.querySelector(".quantity-input") ||
                gift.querySelector("input[type='number']");

            if (giftQtyInput) {
                giftQtyInput.value = 0;
                giftQtyInput.dispatchEvent(new Event("input", { bubbles: true }));
            }

            const giftQtyBox =
                gift.querySelector(".quantity-cstm") ||
                gift.querySelector(".quantity-box");

            if (giftQtyBox) giftQtyBox.style.display = "none";

            const giftAddBtn = gift.querySelector("[class*='add-to-cart']");
            if (giftAddBtn) giftAddBtn.style.display = "block";
        });

        // 3️⃣ Reset main product quantity on main grid
        const mainProduct =
            document.querySelector(`.product-section[data-id="${productId}"]`) ||
            document.querySelector(`.product-item[data-id="${productId}"]`) ||
            document.querySelector(`.product-item[data-product-id="${productId}"]`) ||
            document.querySelector(`.product-item[data-variant-id="${productId}"]`);

        if (mainProduct) {
            const qtyInput =
                mainProduct.querySelector(".quantity__input") ||
                mainProduct.querySelector(".cart-quantity input") ||
                mainProduct.querySelector("input[data-quantity-variant-id]") ||
                mainProduct.querySelector("input[type='number']");

            if (qtyInput) {
                qtyInput.value = 0;
                qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
            }

            const qtyBox =
                mainProduct.querySelector(".quantity-cstm") ||
                mainProduct.querySelector(".quantity-box");

            if (qtyBox) qtyBox.style.display = "none";

            const addBtn = mainProduct.querySelector("[class*='add-to-cart']");
            if (addBtn) addBtn.style.display = "block";
        }

        // 4️⃣ Update localStorage
        let saved = localStorage.getItem("enrollmentStepData");
        if (saved) {
            let data = JSON.parse(saved);
            const removeStep = slide.getAttribute("data-step");

            data.items = data.items.filter(i =>
                !(String(i.id) === String(productId) && String(i.step) === String(removeStep))
            );

            localStorage.setItem("enrollmentStepData", JSON.stringify(data));

            setTimeout(function () {
                updateGiftCOunt();
            }, 400);
        }

        // 5️⃣ Update totals
        if (typeof window.updateGrandTotal === "function") {
            updateGrandTotal();
        }

        console.log("✅ Removed successfully:", productId);
    });


// function updateStepCheckedClass() {
//   const navigationOnly = document.querySelector(".membership-navigation");
//   const proceedBtn = navigationOnly.querySelector(".proceed");
//   const skipBtn = navigationOnly.querySelector(".skip-button");
//   const prevBtn = navigationOnly.querySelector(".prev-button");

//   let allowProceed = false;
//   let allowSkip = false;

//   const activeStep = document.querySelector(".membership.active");
//   const activeIndex = activeStep ? activeStep.getAttribute("data-index") : null;

//   document.querySelectorAll(".subdisable").forEach(stepLi => {
//     const step = stepLi.getAttribute("data-index");
//     const hasProduct = stepLi.querySelector(".product-slide");

//     // 🔥 Active step → skip always remove
//     if (activeIndex === step) {
//       stepLi.classList.remove("skip");
//     }

//     if (hasProduct) {
//       stepLi.classList.add("checked");
//       stepLi.classList.remove("skip");

//       if (step === "1") navigationOnly.classList.add("active");
//       allowProceed = true;

//     } else {
//       if (activeIndex !== step) {
//         // only NON-ACTIVE steps allowed to get skip
//         stepLi.classList.add("skip");
//         stepLi.classList.remove("active");
//       }
//       stepLi.classList.remove("checked");

//       if (step === "1") navigationOnly.classList.remove("active");
//       allowSkip = true;
//     }
//   });

//   // Button enable/disable
//   proceedBtn.disabled = !allowProceed;
//   skipBtn.disabled = !allowSkip;

//   proceedBtn.classList.toggle("disabled", !allowProceed);
//   skipBtn.classList.toggle("disabled", !allowSkip);

//   if (activeIndex === "1") {
//     prevBtn.disabled = true;
//     prevBtn.classList.add("disabled");
//   } else {
//     prevBtn.disabled = false;
//     prevBtn.classList.remove("disabled");
//   }
// }


function updateStepCheckedClass() {
  const navigationOnly = document.querySelector(".membership-navigation");
  const proceedBtn = navigationOnly.querySelector(".proceed");
  const skipBtn = navigationOnly.querySelector(".skip-button");
  const prevBtn = navigationOnly.querySelector(".prev-button");

  let allowProceed = false;
  let allowSkip = false;

  const activeStep = document.querySelector(".membership.active");
  const activeIndex = activeStep ? activeStep.getAttribute("data-index") : null;

  // Add current step info to navigation
  if (activeIndex) {

    navigationOnly.classList.forEach(cls => {
      if (cls.startsWith("step-")) {
        navigationOnly.classList.remove(cls);
      }
    });

    navigationOnly.classList.add(`step-${activeIndex}`);
    navigationOnly.setAttribute("data-step", activeIndex);
  }

  document.querySelectorAll(".subdisable").forEach(stepLi => {
    const step = stepLi.getAttribute("data-index");
    const hasProduct = stepLi.querySelector(".product-slide");

    if (activeIndex === step) {
      stepLi.classList.remove("skip");
    }

    if (hasProduct) {
      stepLi.classList.add("checked");
      stepLi.classList.remove("skip");

      if (step === "1") navigationOnly.classList.add("active");
      allowProceed = true;
    } else {
      if (activeIndex !== step) {
        stepLi.classList.add("skip");
        stepLi.classList.remove("active");
      }

      stepLi.classList.remove("checked");

      if (step === "1") navigationOnly.classList.remove("active");
      allowSkip = true;
    }
  });

  proceedBtn.disabled = !allowProceed;
  skipBtn.disabled = !allowSkip;

  proceedBtn.classList.toggle("disabled", !allowProceed);
  skipBtn.classList.toggle("disabled", !allowSkip);

  if (activeIndex === "1") {
    prevBtn.disabled = true;
    prevBtn.classList.add("disabled");
  } else {
    prevBtn.disabled = false;
    prevBtn.classList.remove("disabled");
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const stepListContainer = document.querySelector(".custom-step-list");
  if (!stepListContainer) return;

  stepListContainer.addEventListener("click", function (e) {
  toggleOrderSection(1);
  toggleOrderSection(2);
  toggleOrderSection(3);
    const stepItem = e.target.closest(".step-list");
    if (!stepItem) return;

    const li = stepItem.closest("li");
    if (!li) return;

    const stepIndex = li.getAttribute("data-index");

    if (stepIndex !== "1") {
      const step1ProductCount =
        document.querySelectorAll("#step1Products .product-slide").length;
        if (document.querySelector(".sponsor-step.active")) {
          return;
        }
      if (step1ProductCount <= 0) {
        alert("You must keep at least one pack");
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
    }

    // -----------------------------
    // Right side steps
    document.querySelectorAll(".custom-step-list li").forEach(el => {
      el.classList.remove("active", "click");
    });
    li.classList.add("active", "click");

    // Left side membership
    document.querySelectorAll(".custom-product-left-content .membership").forEach(el => {
      el.classList.remove("active");
    });

    const activeMembership = document.querySelector(
      `.custom-product-left-content .membership[data-index="${stepIndex}"]`
    );
    if (activeMembership) activeMembership.classList.add("active");

    // Navigation show/hide
    const navigation = document.querySelector(".membership-navigation");
    if (navigation) {
      if (stepIndex === "2" || stepIndex === "3") {
        navigation.classList.add("active");
      } else {
        navigation.classList.remove("active");
      }
    }

    // Sync skip / checked / buttons
    if (typeof updateStepCheckedClass === "function") {
      updateStepCheckedClass();
    }
    console.log("checked Li right side ");
    updateSkipButton();
    updateSkipButtonState();
  });
});



document.addEventListener("DOMContentLoaded", () => {
  setTimeout(updateStepCheckedClass, 500);
});
document.addEventListener("DOMContentLoaded", () => {
  const step = document.querySelector('.membership[step-one]');
  if (!step) return;

  step.addEventListener("click", (e) => {
    const plus = e.target.closest(
      '.product-item button[name="plus"][type="button"]'
    );
    if (!plus) return;

    const productItem = plus.closest(".product-item");

    // ✅ ONLY gift-true PRODUCTS
    if (!productItem || !productItem.hasAttribute("gift-true")) return;

    e.preventDefault();

    const popup = step.querySelector('.gift-popup[data-step="one"]');
    if (!popup) return;

    let totalGiftsSelected = 0;
    popup.querySelectorAll(".gift-item .quantity-input").forEach((input) => {
      totalGiftsSelected += parseInt(input.value) || 0;
    });


      popup.style.display = "block";

  });
});

document.addEventListener("DOMContentLoaded", () => {
  const step = document.querySelector('.membership[step-three]');
  if (!step) return;

  step.addEventListener("click", (e) => {
    const plus = e.target.closest(
      '.product-item button[name="plus"][type="button"]'
    );
    if (!plus) return;

    const productItem = plus.closest(".product-item");

    // ✅ ONLY gift-true PRODUCTS
    if (!productItem || !productItem.hasAttribute("gift-true")) return;
    // Remove active from all gift-true products
    document
      .querySelectorAll(".product-item[gift-true]")
      .forEach((el) => el.classList.remove("active"));

    // Add active to clicked one
    productItem.classList.add("active");
    e.preventDefault();

    const popup = step.querySelector('.gift-popup[data-step="two"]');
    if (!popup) return;

    let totalGiftsSelected = 0;
    popup.querySelectorAll(".gift-item .quantity-input").forEach((input) => {
      totalGiftsSelected += parseInt(input.value) || 0;
    });

    if (totalGiftsSelected < popupOpenLimit(popup)) {
      popup.style.display = "block";
    }
  });
});

$(document).on("click", ".add-to-cart-step-0 button", function (e) {
    const $productItem = $(this).closest(".product-item");
if ($productItem.is("[gift-true]")) {
    $(".product-item[gift-true]").removeClass("active");
    $productItem.addClass("active");
    let $quantityInput = $productItem.find(
        ".quantity-box .cart-quantity input"
    );
    let quantity = parseInt($quantityInput.val()) || 0;

    if (quantity > 0) {
        e.preventDefault();

        const popup = document.querySelector('.gift-popup[data-step="one"]');
        if (!popup) return;

        let totalGiftsSelected = 0;
        popup.querySelectorAll(".gift-item .quantity-input").forEach((input) => {
            totalGiftsSelected += parseInt(input.value) || 0;
        });

        setTimeout(() => {
            if (totalGiftsSelected < stepFreeSprayAllowance("one")) {
                popup.style.display = "block";
            }
        }, 500);
    }
}
 else {
document.querySelector('li.subdisable[data-index="2"] .step-list')?.click();
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}
});

$(document).on("click", ".add-to-cart-step-1 button", function (e) {

    const $productItem = $(this).closest(".product-item");

    const $btn = $(this);
    const mainProductId = $btn.data("product-id"); // 👈 STEP 1 PRODUCT ID
    // ✅ ONLY gift-true PRODUCTS
    if (!$productItem.is("[gift-true]")) return;
    $(".product-item[gift-true]").removeClass("active");
    $productItem.addClass("active");

    let $quantityInput = $productItem.find(
        ".quantity-box .cart-quantity input"
    );
    let quantity = parseInt($quantityInput.val()) || 0;

    if (quantity > 0) {
        $(".error-message").remove();
        e.preventDefault();

        const popup = document.querySelector('.gift-popup[data-step="two"]');
        if (!popup) return;

        let totalGiftsSelected = 0;
        popup.querySelectorAll(".gift-item .quantity-input").forEach((input) => {
            totalGiftsSelected += parseInt(input.value) || 0;
        });

        setTimeout(() => {
            if (totalGiftsSelected < popupOpenLimit(popup)) {
                popup.style.display = "block";
            }
        }, 500);
    }
});
function updateGiftCOunt() {

    pruneOrphanSprays();

    var get_data = JSON.parse(localStorage.getItem("enrollmentStepData") || "{}");
    var items = Array.isArray(get_data.items) ? get_data.items : [];
    var gifts = ownedSprayGifts(Array.isArray(get_data.gifts) ? get_data.gifts : []);

    // 🔥 APPLY SAME LOGIC FOR BOTH STEPS
    ["one", "two"].forEach(function (stepToCheck) {

        var stepItems = items.filter(
            item => item.step === stepToCheck && item.gift === true
        );

        var stepGifts = gifts.filter(
            gift => gift.step === stepToCheck
        );

        var totalMainQty = stepItems.reduce(
            (s, i) => s + (parseInt(i.qty) || 0), 0
        );

        var maxGiftAllowed = stepFreeSprayAllowance(stepToCheck);

        var totalGiftQty = stepGifts.reduce(
            (s, g) => s + (parseInt(g.qty) || 0), 0
        );

        console.log(`🧮 [${stepToCheck}] totalMainQty:`, totalMainQty);
        console.log(`🎁 [${stepToCheck}] totalGiftQty:`, totalGiftQty);
        console.log(`🎁 [${stepToCheck}] maxGiftAllowed:`, maxGiftAllowed);

        /* ================= POPUP LOGIC ================= */
        var popupGift = document.querySelector(
            `.gift-popup[data-step='${stepToCheck}']`
        );
        if (popupGift) {
            if (totalGiftQty >= maxGiftAllowed && maxGiftAllowed > 0) {
                popupGift.classList.add("fullfilqty");
            } else {
                popupGift.classList.remove("fullfilqty");
            }
        }
        /* ================= DATA CLEANUP ================= */
        if (totalMainQty === 0) {

            // 🔥 remove gifts from localStorage
            gifts = gifts.filter(gift => gift.step !== stepToCheck);

            // 🔥 remove gifts from DOM
            document
                .querySelectorAll(
                    `.free.order-list li[type='gift'][data-step='${stepToCheck}'],
                     #step${stepToCheck === "one" ? "1" : "2"}Products [type='gift'][data-step='${stepToCheck}']`
                )
                .forEach(el => el.remove());

            console.log(`🗑 [${stepToCheck}] All gifts removed (main qty = 0)`);

        } else {

            // Over the allowance: trim the latest picks back, keeping each
            // spray's identity, and mirror the result into the popup inputs
            // (saveStepData rebuilds gifts from them on the next click).
            if (totalGiftQty > maxGiftAllowed) {

                var excess = totalGiftQty - maxGiftAllowed;

                for (var i = gifts.length - 1; i >= 0 && excess > 0; i--) {
                    if (gifts[i].step !== stepToCheck) continue;

                    var qty = parseInt(gifts[i].qty) || 0;
                    var cut = Math.min(qty, excess);
                    gifts[i].qty = qty - cut;
                    excess -= cut;

                    var giftInput = popupGift?.querySelector(
                        `.gift-item[data-variant-id="${gifts[i].id}"] .quantity-input`
                    );
                    if (giftInput) giftInput.value = gifts[i].qty;
                }

                gifts = gifts.filter(g => g.qty > 0);
            }
        }
    });

    get_data.gifts = gifts;
    localStorage.setItem("enrollmentStepData", JSON.stringify(get_data));

    console.log("✅ Updated gifts data:", get_data);
}

function getStepFromProduct(productItem) {
  if (!productItem) return null;

  if (productItem.closest(".membership[step-one]")) return "one";
  if (productItem.closest(".membership[step-two]")) return "two";
  if (productItem.closest(".membership[step-three]")) return "three";

  return productItem.getAttribute("data-step");
}
function syncStepThreeGiftPopup(productItem) {
  if (!productItem) return;

  const mainID =
    productItem.getAttribute("data-product-id") ||
    productItem.getAttribute("data-id");

  if (!mainID) return;

  const giftPopup = productItem.querySelector('.gift-popup[data-step="three"]');
  if (!giftPopup) return;

  giftPopup.querySelectorAll(".gift-item").forEach(gift => {
    const giftMainID = gift.getAttribute("data-main-id");
    if (giftMainID !== mainID) return;

    const input = gift.querySelector(".quantity-input");
    if (!input) return;

    // find saved gift from sidebar
    const savedGift = document.querySelector(
      `.product-slide[type="gift"][data-main-id="${mainID}"][data-id="${gift.getAttribute("data-variant-id")}"]`
    );

    if (savedGift) {
      const qty = parseInt(savedGift.getAttribute("data-qty")) || 0;
      input.value = qty;
      input.dispatchEvent(new Event("input", { bubbles: true }));
    }
  });
}



function toggleOrderSection(step) {

  // STEP-1
  if (step === 1) {
    const hasItemsStep1 =
      document.querySelectorAll('.order-section.step-one li').length > 0;

    const step1Section = document.querySelector(".order-section.step-one");

    if (hasItemsStep1) {
      step1Section.classList.remove("hide");
    } else {
      step1Section.classList.add("hide");
    }
  }

  // STEP-2
  if (step === 2) {
    const hasItemsStep2 =
      document.querySelectorAll('.order-section.step-two li').length > 0;

    const step2Section = document.querySelector(".order-section.step-two");

    if (hasItemsStep2) {
      step2Section.classList.remove("hide");
    } else {
      step2Section.classList.add("hide");
    }
  }

  // STEP-3
  if (step === 3) {
    const hasItemsStep3 =
      document.querySelectorAll('.order-section.step-three li').length > 0;

    const step3Section = document.querySelector(".order-section.step-three");

    if (hasItemsStep3) {
      step3Section.classList.remove("hide");
    } else {
      step3Section.classList.add("hide");
    }
  }
}

setTimeout(() => {
  toggleOrderSection(1);
  toggleOrderSection(2);
  toggleOrderSection(3);
}, 300);


function updateSkipButton() {

    const activeStep = document.querySelector(".membership.active");
    const skipBtn = document.querySelector(".skip-button");

    if (!activeStep || !skipBtn) return;

    const currentStep = activeStep.dataset.index;

    const hiddenSteps = (skipBtn.dataset.hiddenSteps || "")
        .split(",")
        .filter(Boolean);

    skipBtn.classList.toggle(
        "hide_button",
        hiddenSteps.includes(currentStep)
    );
}

/* Skip Button code 11-06-26*/


// function updateSkipButtonState(delay = 0) {

//     const run = () => {
//         const activeStep = document.querySelector(".membership.active");
//         const skipBtn = document.querySelector(".skip-button");

//         if (!activeStep || !skipBtn) return;

//         const hasProducts =
//             activeStep.querySelectorAll(".collsecton-data .product-item").length > 0;

//         console.log("Active step:", activeStep.dataset.index);
//         console.log("Has products:", hasProducts);

//         skipBtn.classList.toggle("hide_button", hasProducts);
//     };

//     if (delay > 0) {
//         setTimeout(run, delay);
//     } else {
//         run();
//     }
// }
function updateSkipButtonState(delay = 0) {

    const run = () => {
        const activeStep = document.querySelector(".membership.active");
        const skipBtn = document.querySelector(".skip-button");

        if (!activeStep || !skipBtn) return;

        const selectedProducts =
            activeStep.querySelectorAll(".product-item.enablebtn").length;

        console.log("Active step:", activeStep.dataset.index);
        console.log("Selected products:", selectedProducts);

        skipBtn.classList.toggle(
            "hide_button",
            selectedProducts > 0
        );
    };

    delay ? setTimeout(run, delay) : run();
}